/* Tiếng Việt — Vietnamese */
const vi = {
  nav: {
    home: 'Trang Chủ',
    imageConverter: 'Chuyển Đổi Ảnh',
    imageCompressor: 'Nén Ảnh',
    otherTools: 'Công Cụ Khác',
    resizeImage: 'Thay Đổi Kích Thước',
    cropImage: 'Cắt Ảnh',
    photoEditor: 'Chỉnh Sửa Ảnh',
    removeBackground: 'Xóa Nền',
    watermarkImage: 'Thêm Hình Mờ',
    qrCodeGenerator: 'Tạo Mã QR',
    qrCodeScanner: 'Quét Mã QR',
    aboutUs: 'Giới Thiệu',
    faceBlur: 'Làm Mờ Khuôn Mặt',
  },

  hero: {
    heading: 'Tất Cả Công Cụ Ảnh Bạn Cần',
    subheading: 'Công cụ trực tuyến miễn phí để chuyển đổi, nén, thay đổi kích thước, cắt, chỉnh sửa ảnh. Tất cả xử lý ngay trên trình duyệt — nhanh chóng và an toàn.',
  },

  tools: {
    compressImage: { title: 'Nén Ảnh', desc: 'Nén JPG, PNG, SVG và GIF trong khi vẫn giữ chất lượng.' },
    resizeImage: { title: 'Thay Đổi Kích Thước', desc: 'Thay đổi kích thước theo phần trăm hoặc pixel.' },
    cropImage: { title: 'Cắt Ảnh', desc: 'Cắt JPG, PNG và GIF một cách dễ dàng.' },
    convertToJpg: { title: 'Chuyển sang JPG', desc: 'Chuyển đổi hàng loạt PNG, GIF, TIF, SVG, WEBP sang JPG.' },
    convertFromJpg: { title: 'Chuyển từ JPG', desc: 'Chuyển đổi ảnh JPG sang PNG và GIF.' },
    qrCodeGenerator: { title: 'Tạo Mã QR', desc: 'Tạo mã QR tùy chỉnh cho URL, văn bản, WiFi, danh bạ và hơn thế nữa.' },
    qrCodeScanner: { title: 'Quét Mã QR', desc: 'Quét mã QR ngay lập tức bằng camera hoặc tải ảnh lên.' },
    blurFace: { title: 'Làm Mờ Khuôn Mặt', desc: 'Tự động phát hiện và làm mờ khuôn mặt trong ảnh để bảo vệ quyền riêng tư.' },
    removeBackground: { title: 'Xóa Nền', desc: 'Xóa nền ảnh nhanh chóng với độ chính xác cao.' },
    watermarkImage: { title: 'Thêm Hình Mờ', desc: 'Thêm hình mờ vào ảnh trong vài giây.' },
  },

  whyChoose: {
    label: 'Tại Sao Chọn Chúng Tôi',
    heading: 'Cách Chỉnh Sửa Ảnh Thông Minh Hơn',
    subheading: 'Được tin dùng bởi hàng nghìn nhà sáng tạo, nhà thiết kế và lập trình viên trên toàn thế giới.',
    reasons: {
      fast: { title: 'Nhanh Như Chớp', desc: 'Tất cả xử lý diễn ra trực tiếp trong trình duyệt. Không cần tải lên máy chủ ngoài.' },
      private: { title: '100% An Toàn & Riêng Tư', desc: 'File của bạn không bao giờ rời khỏi thiết bị. Chúng tôi không lưu trữ hay chia sẻ ảnh của bạn.' },
      noLimits: { title: 'Không Giới Hạn, Không Đăng Ký', desc: 'Sử dụng tất cả công cụ tùy thích — hoàn toàn miễn phí.' },
      quality: { title: 'Chất Lượng Chuyên Nghiệp', desc: 'Thuật toán của chúng tôi mang lại kết quả chuyên nghiệp.' },
      batch: { title: 'Xử Lý Hàng Loạt', desc: 'Xử lý nhiều file cùng lúc.' },
      everywhere: { title: 'Hoạt Động Mọi Nơi', desc: 'Hoạt động hoàn hảo trên máy tính, máy tính bảng và điện thoại.' },
    },
    stats: {
      imagesProcessed: 'Ảnh Đã Xử Lý',
      countriesServed: 'Quốc Gia Phục Vụ',
      uptime: 'Thời Gian Hoạt Động',
      freeTools: 'Công Cụ Miễn Phí',
    },
  },

  footer: {
    tagline: 'Công cụ ảnh trực tuyến miễn phí — chuyển đổi, nén, thay đổi kích thước, cắt và chỉnh sửa ảnh trong vài giây.',
    imageTools: 'Công Cụ Ảnh',
    moreTools: 'Thêm Công Cụ',
    company: 'Công Ty',
    contact: 'Liên Hệ',
    allRightsReserved: 'Bảo lưu mọi quyền.',
    privacyPolicy: 'Chính Sách Bảo Mật',
    termsOfService: 'Điều Khoản Dịch Vụ',
  },

  faq: {
    badge: 'FAQ',
    heading: 'Câu Hỏi Thường Gặp',
    subheading: 'Giải đáp nhanh các câu hỏi phổ biến về các công cụ này.',
    stillHaveQuestions: 'Vẫn còn câu hỏi? Chúng tôi sẵn sàng giúp đỡ!',
    reachOut: 'Liên Hệ Với Nhóm Chúng Tôi',
    questionHeader: 'Câu Hỏi',
  },
  contactForm: {
    badge: 'Liên Hệ',
    title: 'Liên HệVới Chúng Tôi',
    subtitle: 'Chúng tôi rất vui được nghe từ bạn. Hãy gửi tin nhắn cho chúng tôi!',
    nameLabel: 'Tên',
    namePlaceholder: 'Họ và tên của bạn',
    emailLabel: 'Email',
    emailPlaceholder: 'ban@email.com',
    subjectLabel: 'Tiêu đề',
    subjectPlaceholder: 'Đây là về việc gì?',
    messageLabel: 'Tin nhắn',
    messagePlaceholder: 'Viết tin nhắn của bạn ở đây…',
    errName: 'Tên là bắt buộc',
    errEmail: 'Email là bắt buộc',
    errEmailInvalid: 'Nhập email hợp lệ',
    errSubject: 'Tiêu đề là bắt buộc',
    errMessage: 'Tin nhắn là bắt buộc',
    sending: 'Đang gửi…',
    send: 'Gửi Tin Nhắn',
    successTitle: 'Tin Nhắn Đã Được Gửi!',
    successMsg: 'Cảm ơn bạn đã liên hệ. Chúng tôi sẽ phản hồi sớm.',
    sendAnother: 'Gửi Tin Khác',
    sendError: 'Đã xảy ra lỗi. Vui lòng thử lại.',
  },
  about: {
    label: 'Giới Thiệu',
    heading: 'Xây Dựng Cho Nhà Sáng Tạo, Bởi Nhà Sáng Tạo',
    subheading: 'Chúng tôi tin rằng công cụ ảnh mạnh mẽ phải miễn phí, nhanh chóng và có thể truy cập bởi tất cả mọi người.',
    missionTitle: 'Sứ Mệnh Của Chúng Tôi',
    missionText: 'photremium.com được xây dựng với mục tiêu đơn giản: cung cấp trải nghiệm chỉnh sửa ảnh trực quan, nhanh nhất và riêng tư nhất trên web.',
    privacyTitle: 'Quyền Riêng Tư Trước Tiên',
    privacyText: 'Chúng tôi không tải lên, lưu trữ hay xử lý ảnh của bạn từ xa. Mọi thứ đều ở lại trên thiết bị của bạn.',
    techTitle: 'Công Nghệ Hiện Đại',
    techText: 'Được xây dựng với công nghệ web tiên tiến nhất bao gồm WebAssembly, Canvas API và React hiện đại.',
    communityTitle: 'Định Hướng Cộng Đồng',
    communityText: 'Mỗi tính năng đều được lấy cảm hứng từ phản hồi của người dùng thực.',
    globalTitle: 'Phạm Vi Toàn Cầu',
    globalText: 'Được sử dụng bởi các nhà sáng tạo từ hơn 120 quốc gia.',
  },

  seo: {
    homeTitle: 'photremium.com — Công Cụ Chuyển Đổi, Nén và Chỉnh Sửa Ảnh Trực Tuyến Miễn Phí',
    homeDesc: 'Chuyển đổi, nén, thay đổi kích thước, cắt và chỉnh sửa ảnh miễn phí trực tuyến.',
    homeKeywords: 'chuyển đổi ảnh, nén ảnh, thay đổi kích thước ảnh, cắt ảnh, chỉnh sửa ảnh',
    aboutTitle: 'Giới Thiệu photremium.com — Sứ Mệnh Của Chúng Tôi',
    aboutDesc: 'Tìm hiểu về photremium.com, bộ công cụ ảnh trực tuyến miễn phí được hàng triệu người tin dùng.',
    aboutKeywords: 'giới thiệu photremium.com, công cụ ảnh, chỉnh sửa ảnh miễn phí',
  },

    privacyPolicyPage: {
    seo: {
      title: 'Chính sách bảo mật — Photremium | Không tải lên máy chủ, không lưu trữ dữ liệu',
      description: 'Chính sách quyền riêng tư của Photremium giải thích cách chúng tôi bảo vệ quyền riêng tư của bạn. Tất cả quá trình xử lý hình ảnh diễn ra 100% trong trình duyệt của bạn — không tải tệp lên bất kỳ máy chủ nào, không thu thập dữ liệu cá nhân, không theo dõi.',
      ogTitle: 'Chính sách bảo mật — Photremium | Không tải lên, không lưu trữ',
      ogDescription: 'Các tập tin của bạn vẫn còn trên thiết bị của bạn. Photremium xử lý cục bộ tất cả hình ảnh trong trình duyệt của bạn mà không cần liên hệ với máy chủ, không lưu trữ dữ liệu và không theo dõi.',
      twitterTitle: 'Chính sách bảo mật — Photremium',
      twitterDescription: 'Công cụ hình ảnh dựa trên trình duyệt 100%. Không tải lên, không lưu trữ, không theo dõi. Đọc chính sách bảo mật đầy đủ của chúng tôi.',
      schemaName: 'Chính sách bảo mật - Photremium',
      schemaDescription: 'Chính sách bảo mật của Photremium - không tải lên máy chủ, không lưu trữ dữ liệu, xử lý hình ảnh 100% trong trình duyệt.'
    },
    hero: {
      badge: 'Chính sách bảo mật',
      titlePrefix: 'Quyền riêng tư của bạn là của chúng tôi',
      titleHighlight: 'Ưu tiên hàng đầu',
      subPrefix: 'photremium.com được xây dựng trên một nguyên tắc đơn giản —',
      subStrong: 'các tập tin của bạn không bao giờ rời khỏi thiết bị của bạn',
      subSuffix: 'Mọi công cụ hình ảnh trên trang web này đều chạy hoàn toàn bên trong trình duyệt của bạn. Không tải lên. Không có đám mây. Không thỏa hiệp.',
      effectiveLabel: 'Hiệu quả',
      lastUpdatedLabel: 'Cập nhật lần cuối',
      worldwideLabel: 'Áp dụng trên toàn thế giới'
    },
    trustCards: [
      {
        title: 'Không có tải lên máy chủ',
        desc: 'Các tập tin của bạn không bao giờ rời khỏi thiết bị của bạn. Tất cả quá trình xử lý đều diễn ra 100% trong trình duyệt.'
      },
      {
        title: 'Không lưu trữ dữ liệu',
        desc: 'Chúng tôi không lưu trữ gì về bạn, hình ảnh hoặc hoạt động của bạn.'
      },
      {
        title: 'Không theo dõi',
        desc: 'Không theo dõi hành vi, không lấy dấu vân tay, không lập hồ sơ.'
      },
      {
        title: 'Thân thiện với GDPR',
        desc: 'Được thiết kế từ đầu để tôn trọng các quy định về quyền riêng tư toàn cầu.'
      }
    ],
    contentsTitle: 'Nội dung',
    toc: {
      overview: 'Tổng quan',
      'no-upload': 'Không có máy chủ xử lý',
      'data-collect': 'Dữ liệu chúng tôi thu thập',
      cookies: 'Cookie & Lưu trữ',
      'third-party': 'Dịch vụ của bên thứ ba',
      analytics: 'Phân tích',
      children: 'Quyền riêng tư của trẻ em',
      rights: 'Quyền của bạn',
      security: 'Bảo vệ',
      changes: 'Thay đổi chính sách',
      contact: 'Liên hệ với chúng tôi'
    },
    sections: {
      overview: {
        title: '1. Tổng quan',
        subtitle: 'Chính sách này bao gồm những gì',
        p1Prefix: 'Chính sách quyền riêng tư này mô tả cách',
        p1Middle: '("chúng tôi", "chúng tôi" hoặc "của chúng tôi") xử lý - hay chính xác hơn là',
        p1Italic: 'không xử lý',
        p1Suffix: 'thông tin cá nhân của bạn khi bạn sử dụng các công cụ hình ảnh trực tuyến miễn phí của chúng tôi tại',
        p2: 'Không giống như các ứng dụng web truyền thống gửi tệp đến máy chủ từ xa để xử lý, photremium.com sử dụng API trình duyệt hiện đại (API Canvas, WebAssugging, WebWorkers) để thực hiện mọi thao tác cục bộ trên thiết bị của bạn. Kết quả: không truyền dữ liệu, không lưu trữ, không rủi ro.',
        calloutLabel: 'Tóm tắt bằng tiếng Anh đơn giản:',
        calloutText: 'Chúng tôi không thể nhìn thấy hình ảnh của bạn, chúng tôi không muốn và công nghệ của chúng tôi được thiết kế đặc biệt để chúng tôi không bao giờ có thể.'
      },
      noUpload: {
        title: '2. Không xử lý máy chủ - Chưa bao giờ',
        subtitle: 'Công cụ của chúng tôi thực sự hoạt động như thế nào',
        introPrefix: 'Mọi công cụ trên photremium.com — công cụ chuyển đổi hình ảnh, nén, thay đổi kích thước, xóa nền, làm mờ khuôn mặt, hình mờ, cắt xén và mã QR — đều xử lý tệp của bạn',
        introStrong: '100% bên trong trình duyệt web của bạn',
        introSuffix: 'sử dụng JavaScript phía máy khách và WebAssembly.',
        points: [
          {
            label: 'Không có tập tin tải lên bao giờ xảy ra.',
            text: 'Khi bạn chọn một tệp, API tệp của trình duyệt của bạn sẽ đọc và xử lý trong bộ nhớ — tệp đó không bao giờ được gửi qua mạng.'
          },
          {
            label: 'Không có máy chủ nhận được hình ảnh của bạn.',
            text: 'CDN của chúng tôi chỉ phục vụ các nội dung HTML, CSS và JavaScript cần thiết để chạy ứng dụng — chứ không phải các tệp của bạn.'
          },
          {
            label: 'Không có lưu trữ tạm thời.',
            text: 'Kết quả đã xử lý chỉ tồn tại trong bộ nhớ trình duyệt của bạn và được giải phóng khi bạn đóng hoặc điều hướng khỏi trang.'
          },
          {
            label: 'Hoạt động ngoại tuyến.',
            text: 'Hầu hết các công cụ tiếp tục hoạt động mà không cần kết nối internet sau lần tải trang đầu tiên — thêm bằng chứng nữa là không có máy chủ nào liên quan.'
          }
        ],
        callout: 'Bạn có thể tự xác minh điều này: mở tab Mạng của trình duyệt trong Công cụ dành cho nhà phát triển, chọn hình ảnh và xác nhận rằng không có dữ liệu tệp nào được truyền đến bất kỳ máy chủ bên ngoài nào.'
      },
      dataCollect: {
        title: '3. Dữ liệu chúng tôi thu thập (và không thu thập)',
        subtitle: 'Hoàn toàn minh bạch về thực hành dữ liệu',
        headers: {
          type: 'Kiểu dữ liệu',
          collected: 'Thu thập?',
          whereWhy: 'Ở đâu / Tại sao'
        },
        rows: [
          {
            type: 'Hình ảnh/tập tin của bạn',
            badge: 'Không bao giờ',
            variant: 'màu xanh lá',
            showX: true,
            whereWhy: 'Được xử lý hoàn toàn trong trình duyệt của bạn — không bao giờ được truyền đi'
          },
          {
            type: 'Tên/địa chỉ email',
            badge: 'Không bao giờ',
            variant: 'màu xanh lá',
            showX: true,
            whereWhy: 'Không cần tài khoản hoặc đăng ký để sử dụng bất kỳ công cụ nào'
          },
          {
            type: 'địa chỉ IP',
            badge: 'Tối thiểu',
            variant: 'xám',
            showX: false,
            whereWhy: 'Nhật ký máy chủ web tiêu chuẩn được lưu giữ <= 30 ngày, không bị ràng buộc với danh tính'
          },
          {
            type: 'Loại trình duyệt/hệ điều hành',
            badge: 'Tối thiểu',
            variant: 'xám',
            showX: false,
            whereWhy: 'Được gửi tự động bởi trình duyệt của bạn; chỉ được sử dụng để tương thích'
          },
          {
            type: 'Các trang đã truy cập / số lần nhấp chuột',
            badge: 'tổng hợp',
            variant: 'màu xanh da trời',
            showX: false,
            whereWhy: 'Chỉ phân tích ẩn danh (không có nhận dạng cá nhân)'
          },
          {
            type: 'Tùy chọn ngôn ngữ',
            badge: 'Chỉ địa phương',
            variant: 'màu xanh da trời',
            showX: false,
            whereWhy: 'Đã lưu vào localStorage trên thiết bị của bạn — chưa bao giờ được gửi cho chúng tôi'
          },
          {
            type: 'Dữ liệu thanh toán / tài chính',
            badge: 'Không bao giờ',
            variant: 'màu xanh lá',
            showX: true,
            whereWhy: 'photremium.com hoàn toàn miễn phí và không cần thanh toán'
          }
        ]
      },
      cookies: {
        title: '4. Cookie & bộ nhớ cục bộ',
        subtitle: 'Những gì được lưu trữ trên thiết bị của bạn',
        intro: 'photremium.com không sử dụng cookie quảng cáo, không có cookie theo dõi trên nhiều trang web và không có cookie của bên thứ ba. Bộ nhớ trình duyệt duy nhất mà chúng tôi sử dụng là dành cho chức năng thiết yếu của trang web.',
        points: [
          {
            label: 'Tùy chọn ngôn ngữ',
            text: 'Được lưu trữ trong localStorage để trang web ghi nhớ ngôn ngữ ưa thích của bạn giữa các lần truy cập. Không bao giờ được gửi đến máy chủ của chúng tôi.'
          },
          {
            label: 'Tùy chọn chủ đề/giao diện người dùng',
            text: 'Nếu bạn đặt tùy chọn hiển thị, nó sẽ chỉ được lưu cục bộ trên thiết bị của bạn.'
          },
          {
            label: 'Không có cookie phiên.',
            text: 'photremium.com không có hệ thống đăng nhập nên không có cookie ID phiên nào được ghi.'
          }
        ],
        callout: 'Bạn có thể xóa tất cả bộ nhớ cục bộ của photremium.com bất kỳ lúc nào thông qua cài đặt trình duyệt của bạn (Cài đặt -> Quyền riêng tư -> Xóa dữ liệu duyệt web -> Dữ liệu được lưu trong bộ nhớ cache & cookie). Làm như vậy không ảnh hưởng gì đến khả năng sử dụng các công cụ của bạn.'
      },
      thirdParty: {
        title: '5. Dịch vụ của bên thứ ba',
        subtitle: 'Các dịch vụ bên ngoài chúng tôi sử dụng và lý do',
        intro: 'photremium.com sử dụng một bộ dịch vụ bên thứ ba đáng tin cậy tối thiểu cho cơ sở hạ tầng và hiệu suất. Không có dịch vụ nào trong số này nhận được hình ảnh của bạn hoặc bất kỳ thông tin nhận dạng cá nhân nào.',
        headers: {
          service: 'Dịch vụ',
          purpose: 'Mục đích',
          dataShared: 'Dữ liệu được chia sẻ',
          privacyPolicy: 'Chính sách bảo mật'
        },
        rows: [
          {
            service: 'Trang đám mây',
            purpose: 'Lưu trữ & phân phối CDN nội dung trang web',
            dataShared: 'Địa chỉ IP, tiêu đề HTTP (tiêu chuẩn)',
            privacyLink: 'https://www.cloudflare.com/privacypolicy/',
            privacyText: 'cloudflare.com/privacypolicy'
          },
          {
            service: 'Phông chữ tuyệt vời',
            purpose: 'Phông chữ biểu tượng được tải từ CDN',
            dataShared: 'Địa chỉ IP (chỉ yêu cầu CSS)',
            privacyLink: 'https://fontawesome.com/privacy',
            privacyText: 'fontawesome.com/privacy'
          },
          {
            service: 'Phông chữ của Google',
            purpose: 'Đang tải kiểu chữ (nếu có)',
            dataShared: 'Địa chỉ IP (chỉ yêu cầu phông chữ)',
            privacyLink: 'https://policies.google.com/privacy',
            privacyText: 'policies.google.com'
          }
        ],
        outro: 'Chúng tôi không chia sẻ dữ liệu của bạn với các nhà quảng cáo, nhà môi giới dữ liệu hoặc bất kỳ bên thứ ba nào khác ngoài các nhà cung cấp cơ sở hạ tầng được liệt kê ở trên.'
      },
      analytics: {
        title: '6. Phân tích',
        subtitle: 'Dữ liệu sử dụng tổng hợp, tôn trọng quyền riêng tư',
        introPrefix: 'Để hiểu công cụ nào phổ biến và cách cải thiện trang web, chúng tôi có thể thu thập',
        introStrong: 'tổng hợp, ẩn danh',
        introSuffix: 'thống kê sử dụng như:',
        points: [
          'Số lượt xem trang trên mỗi công cụ (không có nhận dạng người dùng)',
          'Nguồn giới thiệu (ví dụ: tìm kiếm của Google, liên kết trực tiếp) — không có dữ liệu cá nhân',
          'Dữ liệu địa lý cấp quốc gia (không phải thành phố hoặc vị trí chính xác)',
          'Loại trình duyệt/thiết bị để phân tích khả năng tương thích'
        ],
        calloutLabel: 'Không có dữ liệu nào được liên kết với cá nhân bạn.',
        calloutText: 'Chúng tôi không sử dụng Google Analytics hoặc Meta Pixel. Mọi phân tích chúng tôi sử dụng đều là công cụ ưu tiên quyền riêng tư (ví dụ: Hợp lý hoặc tương tự).'
      },
      children: {
        title: '7. Quyền riêng tư của trẻ em',
        subtitle: 'COPPA và tuân thủ an toàn trẻ em',
        p1: 'photremium.com không cố ý thu thập bất kỳ thông tin cá nhân nào từ trẻ em dưới 13 tuổi (hoặc 16 tuổi ở Liên minh Châu Âu theo GDPR). Vì chúng tôi không thu thập dữ liệu cá nhân từ bất kỳ người dùng nào nên không có gì đặc biệt để làm đối với người dùng trẻ tuổi — trang web này an toàn như nhau cho mọi người.',
        p2Prefix: 'Nếu bạn tin rằng một đứa trẻ bằng cách nào đó đã gửi thông tin cá nhân thông qua biểu mẫu liên hệ của chúng tôi, vui lòng liên hệ ngay với chúng tôi theo địa chỉ',
        p2Suffix: 'và chúng tôi sẽ nhanh chóng xóa nó.'
      },
      rights: {
        title: '8. Quyền của bạn',
        subtitle: 'GDPR, CCPA và quyền riêng tư toàn cầu',
        intro: 'Vì photremium.com không thu thập thông tin nhận dạng cá nhân nên hầu hết các quyền đối với dữ liệu đều được áp dụng một cách tầm thường — không có dữ liệu nào về bạn để truy cập, chỉnh sửa hoặc xóa. Tuy nhiên, chúng tôi hoàn toàn thừa nhận và tôn trọng các quyền sau:',
        points: [
          {
            label: 'Quyền truy cập',
            text: 'Bạn có thể yêu cầu bản sao của bất kỳ dữ liệu nào chúng tôi lưu giữ về bạn. (Không có gì ngoài nhật ký ẩn danh.)'
          },
          {
            label: 'Quyền sửa chữa',
            text: 'Bạn có thể yêu cầu chỉnh sửa dữ liệu cá nhân không chính xác.'
          },
          {
            label: 'Quyền xóa ("Quyền được lãng quên")',
            text: 'Bạn có thể yêu cầu xóa bất kỳ dữ liệu cá nhân nào mà chúng tôi nắm giữ (Điều 17 GDPR, CCPA).'
          },
          {
            label: 'Quyền phản đối/từ chối',
            text: 'Bạn có thể chọn không tham gia bất kỳ bộ sưu tập phân tích nào trong tương lai bằng cách sử dụng công cụ chặn quảng cáo hoặc chọn không tham gia ở cấp trình duyệt.'
          },
          {
            label: 'Quyền di chuyển dữ liệu',
            text: 'Tất cả tác phẩm của bạn được tải trực tiếp xuống thiết bị của bạn — không cần yêu cầu xuất.'
          }
        ],
        callout: 'Các quyền này áp dụng cho tất cả người dùng trên toàn thế giới bất kể khu vực pháp lý — chúng tôi áp dụng tiêu chuẩn cao nhất (GDPR) làm cơ sở của mình.'
      },
      security: {
        title: '9. Bảo mật',
        subtitle: 'Cách chúng tôi bảo vệ trải nghiệm của bạn',
        intro: 'Dữ liệu an toàn nhất là dữ liệu không bao giờ được thu thập. Kiến trúc phía máy khách của photremium.com có ​​nghĩa là vi phạm máy chủ không thể làm lộ các tệp của bạn vì các tệp của bạn không bao giờ có trên máy chủ của chúng tôi. Các biện pháp an ninh bổ sung bao gồm:',
        points: [
          {
            label: 'Thực thi HTTPS',
            text: 'Tất cả lưu lượng truy cập giữa trình duyệt của bạn và CDN của chúng tôi được mã hóa qua TLS 1.2+ với HSTS.'
          },
          {
            label: 'Chính sách bảo mật nội dung (CSP)',
            text: 'Các tiêu đề nghiêm ngặt ngăn chặn việc chèn tập lệnh chéo trang và chèn tập lệnh nội tuyến.'
          },
          {
            label: 'Kiểm tra phụ thuộc thường xuyên',
            text: 'Chúng tôi kiểm tra và cập nhật các gói npm thường xuyên để vá các lỗ hổng đã biết.'
          }
        ],
        disclosurePrefix: 'Tiết lộ có trách nhiệm',
        disclosureTextPrefix: 'Tìm thấy một vấn đề bảo mật? Gửi email cho chúng tôi tại',
        disclosureTextSuffix: 'và chúng tôi sẽ trả lời trong vòng 48 giờ.'
      },
      changes: {
        title: '10. Những thay đổi đối với Chính sách này',
        subtitle: 'Cách chúng tôi xử lý các cập nhật chính sách',
        intro: 'Đôi khi, chúng tôi có thể cập nhật Chính sách quyền riêng tư này để phản ánh những thay đổi trong thực tiễn, công cụ hoặc yêu cầu pháp lý của chúng tôi. Khi chúng tôi làm:',
        points: [
          {
            label: '"Cập nhật lần cuối"',
            text: 'ngày ở đầu trang này sẽ được sửa đổi.'
          },
          {
            label: 'Thay đổi vật chất',
            text: 'sẽ được thông báo qua thông báo nổi bật trên trang chủ trong ít nhất 30 ngày.'
          },
          {
            label: 'Các phiên bản trước',
            text: 'của chính sách này sẽ được lưu trữ và cung cấp theo yêu cầu.'
          }
        ],
        outro: 'Việc tiếp tục sử dụng photremium.com sau khi các thay đổi được công bố sẽ đồng nghĩa với việc chấp nhận chính sách cập nhật. Chúng tôi khuyến khích bạn xem lại trang này định kỳ.'
      },
      contact: {
        title: '11. Yêu cầu liên hệ và dữ liệu',
        subtitle: 'Liên hệ về quyền riêng tư',
        p1Prefix: 'Nếu có bất kỳ câu hỏi, thắc mắc hoặc yêu cầu dữ liệu chính thức nào liên quan đến Chính sách quyền riêng tư này, vui lòng liên hệ với chúng tôi. Chúng tôi mong muốn phản hồi tất cả các câu hỏi liên quan đến quyền riêng tư trong vòng',
        p1Strong: '5 ngày làm việc'
      }
    },
    footer: {
      privacyQuestionsTitle: 'Câu hỏi về quyền riêng tư?',
      privacyQuestionsDesc: 'Hãy gửi cho chúng tôi câu hỏi về quyền riêng tư, yêu cầu dữ liệu hoặc mối quan ngại của bạn và chúng tôi sẽ phản hồi kịp thời.',
      versionHistoryTitle: 'Lịch sử phiên bản',
      v2Label: 'v2.0 — Major rewrite',
      v11Label: 'v1.1 — Added CCPA rights',
      v10Label: 'v1.0 — Initial policy'
    }
  },
common: {
    new: 'Mới!',
    download: 'Tải Về',
    downloadAll: 'Tải Tất Cả',
    downloadAs: 'Tải về dạng:',
    zip: 'ZIP',
    separate: 'Riêng biệt',
    upload: 'Tải Lên',
    dragDrop: 'Kéo & thả ảnh vào đây hoặc nhấp để duyệt',
    remove: 'Xóa',
    reset: 'Đặt Lại',
    apply: 'Áp Dụng',
    cancel: 'Hủy',
    clear: 'Xóa',
    close: 'Đóng',
    save: 'Lưu',
    processing: 'Đang xử lý...',
    noFiles: 'Chưa chọn file',
    selectFiles: 'Chọn File',
    or: 'hoặc',
    browseFiles: 'Duyệt File',
    dropHere: 'Thả ảnh vào đây',
    chooseFiles: 'Chọn File',
    pasteHint: 'Bạn cũng có thể dán ảnh',
    quality: 'Chất Lượng',
    width: 'Chiều Rộng',
    height: 'Chiều Cao',
    format: 'Định Dạng',
    compression: 'Nén',
    preview: 'Xem Trước',
    original: 'Gốc',
    result: 'Kết Quả',
    before: 'Trước',
    after: 'Sau',
    startOver: 'Bắt Đầu Lại',
    startOverConfirm: 'Xóa tất cả ảnh và bắt đầu lại?',
    addMoreImages: 'Thêm Ảnh',
    addImage: 'Thêm Ảnh',
    images: 'ảnh',
    totalSize: 'Tổng Kích Thước',
    size: 'Kích Thước',
    type: 'Loại',
    unsavedEdits: 'Bạn có các chỉnh sửa chưa lưu. Rời khỏi trang này?',
    compareSlider: 'Thanh So Sánh',
    toggleToolsPanel: 'Bật/Tắt Bảng Công Cụ',
    closePanel: 'Đóng Bảng',
    zoomIn: 'Phóng To',
    zoomOut: 'Thu Nhỏ',
    fit: 'Vừa Khít',
    none: 'Không',
  },

  compressor: {
    seo: {
      uploadTitle: 'Nén Ảnh — Nén JPG, PNG, SVG, GIF Miễn Phí | photremium.com',
      uploadDesc: 'Nén ảnh JPG, PNG, SVG và GIF miễn phí trực tuyến. Giảm kích thước file lên đến 80% trong khi vẫn giữ chất lượng.',
      uploadKeywords: 'nén ảnh, nén jpg, nén png, giảm kích thước ảnh',
      workspaceTitle: 'Đang Nén Ảnh — Công Cụ Nén Ảnh photremium.com',
      workspaceDesc: 'Điều chỉnh mức độ nén và tải về ảnh đã tối ưu.',
      workspaceKeywords: 'nén ảnh, tối ưu ảnh',
    },
    title: 'Nén Ảnh',
    desc: 'Nén ảnh JPG, PNG và GIF lên đến 80%. Nhanh chóng và an toàn.',
    toCompress: 'để nén',
    compressionForAll: 'Nén cho tất cả ảnh',
    summary: 'Tóm Tắt',
    originalSize: 'Kích Thước Gốc',
    compressed: 'Đã Nén',
    saved: 'Đã Tiết Kiệm',
    compressionLabel: 'Nén:',
    compressing: 'Đang nén…',
    compressDownload: 'Nén & Tải Về',
    lowQualityWarning: 'Mức nén cao có thể làm giảm độ rõ nét của ảnh đáng kể.',
    blog: {
      tocTitle: 'Mục lục',
      title: 'Blog Nén Ảnh',
      formatsIntro: 'Công cụ của chúng tôi hỗ trợ tất cả định dạng ảnh, vì vậy bạn có thể nén mọi ảnh một cách mượt mà. Danh sách đầy đủ định dạng ở bên dưới:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. Công cụ nén ảnh là gì?',
          paragraphs: [
            'Công cụ nén ảnh là phần mềm hoặc dịch vụ trực tuyến giúp giảm dung lượng tệp ảnh trong khi vẫn giữ chất lượng hiển thị. Tuy nhiên, nén quá mạnh có thể làm giảm chất lượng rõ rệt.',
          ],
          listTitle: 'LOẠI:',
          bullets: [
            'Nén mất dữ liệu: giảm dung lượng bằng cách loại bỏ một phần dữ liệu ảnh. Chất lượng có thể giảm, nhưng ở mức vừa phải thường khó nhận thấy bằng mắt thường.',
            'Nén không mất dữ liệu: giảm dung lượng tệp mà không ảnh hưởng đến chất lượng hiển thị của ảnh.',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. Vì sao chọn công cụ của chúng tôi?',
          bullets: [
            'Công cụ nén ảnh dùng AI của chúng tôi hoạt động mượt trên mọi thiết bị và cho kết quả tốt nhất có thể.',
            'Bạn có thể nén nhiều ảnh cùng lúc (thậm chí hơn 100 ảnh) chỉ với một lần bấm.',
            'Không cần tải ảnh lên máy chủ. Tất cả xử lý diễn ra cục bộ ngay trong trình duyệt của bạn.',
            'Công cụ nén ảnh của chúng tôi hoàn toàn miễn phí vĩnh viễn, và bạn có thể chia sẻ cho bạn bè.',
            'Bạn có thể chọn tỷ lệ nén theo nhu cầu của mình.',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. Hướng dẫn từng bước',
          steps: [
            {
              heading: '1. Chọn ảnh bạn muốn nén.',
              bullets: [
                'Kéo và thả ảnh vào ô tải lên.',
                'Bạn cũng có thể sao chép ảnh và dán vào ô bằng (Ctrl + V).',
                'Bạn cũng có thể chọn ảnh qua trình quản lý tệp bằng nút chọn.',
              ],
            },
            {
              heading: '2. Sau đó chọn phần trăm nén.',
              bullets: [
                'Thanh trượt ngang giúp bạn chọn mức nén thuận tiện. Hãy tham khảo các khoảng sau để có kết quả chính xác hơn.',
              ],
              table: {
                headers: ['Phần trăm nén', 'Kết quả'],
                rows: [
                  ['1%  đến  40%', 'Chất lượng tốt nhất'],
                  ['41%  đến  60%', 'Chất lượng bình thường (Khuyến nghị)'],
                  ['61%  đến  100%', 'Chất lượng thấp'],
                ],
              },
            },
            {
              heading: '3. Kiểm tra dung lượng bạn đã tiết kiệm.',
              paragraphs: [
                'Tất cả chỉ số dung lượng được hiển thị theo thời gian thực. Bạn có thể thấy rõ đã tiết kiệm được bao nhiêu và điều chỉnh mức nén để đạt kích thước mong muốn.',
              ],
            },
            {
              heading: '4. Chọn cách tải xuống bằng nút chuyển.',
              bullets: [
                'ZIP: nếu bạn nén nhiều ảnh, tùy chọn này sẽ xuất hiện. Chọn ZIP để gom tất cả ảnh đã nén vào một tệp ZIP (khuyến nghị khi có nhiều ảnh).',
                'Tách riêng: tùy chọn này tải từng ảnh riêng lẻ thay vì một tệp ZIP duy nhất (khuyến nghị với số lượng ít, dưới 10 ảnh).',
              ],
            },
            {
              heading: '5. Nén và tải ảnh.',
              paragraphs: [
                'Nút này sẽ tự động tải xuống tất cả ảnh đã nén theo tùy chọn tải xuống bạn đã chọn.',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. Lợi ích của công cụ nén ảnh.',
          bullets: [
            'Giảm chi phí lưu trữ: nén ảnh giúp giảm đáng kể dung lượng tệp.',
            'Tải nhanh hơn: ảnh đã nén tải nhanh hơn, cải thiện trải nghiệm người dùng trên web/app.',
            'Giải pháp giới hạn Gmail: Gmail giới hạn tệp đính kèm 25MB, nén ảnh giúp gửi được nhiều tệp hơn.',
            'Chia sẻ và truyền tải nhanh hơn: tệp lớn mất nhiều thời gian truyền; nén ảnh giúp tiết kiệm thời gian và dữ liệu.',
            'Tối ưu bài thuyết trình: ảnh chưa nén khiến tệp trình chiếu nặng, còn ảnh đã nén giúp giảm kích thước đáng kể.',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. Định dạng được hỗ trợ.',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: 'Chuyển Đổi Ảnh — Chuyển PNG, JPG, WEBP, GIF, SVG Miễn Phí | photremium.com',
      uploadDesc: 'Chuyển đổi ảnh giữa JPG, PNG, WEBP, GIF, SVG, TIFF và BMP. Công cụ chuyển đổi định dạng ảnh miễn phí.',
      uploadKeywords: 'chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',
      workspaceKeywords: 'chuyển đổi ảnh, công cụ chuyển đổi định dạng',

      routeKeywords: {

        'png-to-jpg': 'png để chuyển đổi jpg, png to jpg, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'jpg-to-png': 'jpg để chuyển đổi png, jpg to png, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'png-to-webp': 'png để chuyển đổi webp, png to webp, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'jpg-to-webp': 'jpg để chuyển đổi webp, jpg to webp, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'webp-to-jpg': 'webp để chuyển đổi jpg, webp to jpg, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'webp-to-png': 'webp để chuyển đổi png, webp to png, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'gif-to-jpg': 'gif để chuyển đổi jpg, gif to jpg, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'gif-to-png': 'gif để chuyển đổi png, gif to png, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'bmp-to-jpg': 'bmp để chuyển đổi jpg, bmp to jpg, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'bmp-to-png': 'bmp để chuyển đổi png, bmp to png, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'svg-to-png': 'svg để chuyển đổi png, svg to png, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'svg-to-jpg': 'svg để chuyển đổi jpg, svg to jpg, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'tiff-to-jpg': 'tiff để chuyển đổi jpg, tiff to jpg, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'tiff-to-png': 'tiff để chuyển đổi png, tiff to png, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'jpg-to-gif': 'jpg để chuyển đổi gif, jpg to gif, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'png-to-gif': 'png để chuyển đổi gif, png to gif, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'jpg-to-bmp': 'jpg để chuyển đổi bmp, jpg to bmp, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'png-to-bmp': 'png để chuyển đổi bmp, png to bmp, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'webp-to-gif': 'webp để chuyển đổi gif, webp to gif, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'jpg-to-ico': 'jpg để chuyển đổi ico, jpg to ico, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'png-to-ico': 'png để chuyển đổi ico, png to ico, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'jpg-to-svg': 'jpg để chuyển đổi svg, jpg to svg, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'png-to-svg': 'png để chuyển đổi svg, png to svg, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'webp-to-svg': 'webp để chuyển đổi svg, webp to svg, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'gif-to-svg': 'gif để chuyển đổi svg, gif to svg, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'bmp-to-svg': 'bmp để chuyển đổi svg, bmp to svg, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

        'tiff-to-svg': 'tiff để chuyển đổi svg, tiff to svg, chuyển đổi ảnh, png sang jpg, jpg sang png, chuyển đổi webp',

      },
    },
    title: 'Chuyển Đổi Ảnh',
    desc: 'Chuyển đổi ảnh giữa JPG, PNG, WEBP, GIF, SVG, TIFF và BMP. Chuyển đổi hàng loạt nhiều file.',
    toConvert: 'để chuyển đổi',
    convertSettings: 'Cài Đặt Chuyển Đổi',
    detected: 'Đã Phát Hiện',
    convertTo: 'Chuyển sang',
    converting: 'Đang chuyển đổi…',
    convertToFormat: 'Chuyển sang {format}',
    popularConversions: 'Chuyển Đổi Phổ Biến',
    convertingTo: 'Đang chuyển sang',
    all: 'Tất Cả',
  },

  resizer: {
    seo: {
      uploadTitle: 'Thay Đổi Kích Thước Ảnh — Thay Đổi JPG, PNG Miễn Phí | photremium.com',
      uploadDesc: 'Thay đổi kích thước ảnh theo pixel hoặc phần trăm miễn phí trực tuyến.',
      uploadKeywords: 'thay đổi kích thước ảnh, công cụ thay đổi kích thước, thay đổi jpg, thay đổi png',
      workspaceTitle: 'Đang Thay Đổi Kích Thước — photremium.com',
      workspaceDesc: 'Thay đổi kích thước ảnh miễn phí trực tuyến.',
      workspaceKeywords: 'thay đổi kích thước ảnh, công cụ thay đổi kích thước',
    },
    title: 'Thay Đổi Kích Thước Ảnh',
    desc: 'Xác định kích thước bằng pixel, phần trăm, cm hoặc inch và thay đổi ngay lập tức.',
    toResize: 'để thay đổi kích thước',
    resizeSettings: 'Cài Đặt Kích Thước',
    resizeBy: 'Thay đổi theo:',
    byPixels: 'Pixel',
    byPercentage: 'Phần Trăm',
    byCentimeters: 'Centimet',
    byInches: 'Inch',
    advanced: 'Nâng Cao',
    lockAspect: 'Khóa Tỷ Lệ',
    unlockAspect: 'Mở Khóa Tỷ Lệ',
    dontEnlarge: 'Không phóng to nếu ảnh gốc nhỏ hơn',
    resizing: 'Đang thay đổi kích thước…',
    resizeDownload: 'Thay Đổi & Tải Về',
    blog: {
      tocTitle: 'Mục lục',
      title: 'Blog thay đổi kích thước ảnh',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. Vì sao nên dùng công cụ thay đổi kích thước ảnh?',
          paragraphs: [
            'Công cụ thay đổi kích thước ảnh là phần mềm/công cụ dùng để thay đổi kích thước ảnh. Bạn có thể chỉnh chiều cao, chiều rộng hoặc cả hai để đạt kích thước mong muốn. Điều này đặc biệt hữu ích cho các nền tảng mạng xã hội có giới hạn kích thước khi đăng/tải ảnh.',
          ],
          listTitle: 'Ví dụ:',
          bullets: [
            'Bài đăng Instagram: 1080 x 1080px (vuông)',
            'Bài đăng Facebook: 1200 x 630px',
            'Bài đăng X (Twitter): 1200 x 675px',
            'Instagram Story: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. Vì sao chọn công cụ thay đổi kích thước của chúng tôi?',
          paragraphs: [
            'Công cụ thay đổi kích thước ảnh bằng AI của chúng tôi cho phép bạn chỉnh ảnh chính xác và rất nhanh. Công cụ hoạt động mượt trên mọi thiết bị và không cần cài ứng dụng. Tất cả tính năng đều dùng trực tuyến ngay trên trình duyệt.',
          ],
          bullets: [
            'Bạn có thể đổi kích thước nhiều ảnh cùng lúc (thậm chí 100+). Với thiết bị mạnh, có thể xử lý 400–500 ảnh chỉ trong vài giây.',
            'Mọi xử lý diễn ra cục bộ trong trình duyệt. Không cần tải ảnh lên máy chủ nên ảnh không rời khỏi thiết bị của bạn.',
            'Hỗ trợ nhiều đơn vị thay đổi kích thước.',
            'Bạn có thể giữ đúng tỷ lệ ảnh chỉ với một ô chọn.',
            'Khi xử lý nhiều ảnh, bạn có thể tải từng ảnh riêng hoặc tải gói ZIP.',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. Hướng dẫn từng bước',
          steps: [
            {
              heading: 'Trước tiên, chọn ảnh (một hoặc nhiều ảnh) bạn muốn thay đổi kích thước. Có nhiều cách để chọn.',
              bullets: [
                'Kéo và thả ảnh vào vùng tải lên.',
                'Bạn cũng có thể dán ảnh bằng phím tắt “Ctrl + V”.',
                'Hoặc bấm “Choose Files” để chọn ảnh từ trình quản lý tệp.',
              ],
            },
            {
              heading: 'Sau đó, chọn đơn vị thay đổi kích thước. Các đơn vị hiện có gồm:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'Tiếp theo, đặt chiều cao và chiều rộng để đổi kích thước. Bạn cũng có thể giữ tỷ lệ ảnh bằng ô chọn.',
            },
            {
              heading: 'Nếu không muốn phóng to vượt quá kích thước gốc, hãy bật “Don’t enlarge if original is smaller”.',
            },
            {
              heading: 'Tiếp theo, chọn phương thức tải về.',
              bullets: [
                'Chọn ZIP nếu bạn muốn tải tất cả ảnh đã đổi kích thước trong một tệp zip.',
                'Chọn “separate” nếu bạn muốn tải từng ảnh riêng lẻ.',
              ],
            },
            {
              heading: 'Cuối cùng, bấm “Resize & Download” để tải xuống theo lựa chọn của bạn.',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. Lợi ích của công cụ thay đổi kích thước: lợi ích lớn nhất là giúp ảnh hiển thị đúng trên trang web và bài đăng mạng xã hội.',
          tocLabel: '4. Lợi ích của công cụ thay đổi kích thước',
          bullets: [
            'Nâng cao UX: kích thước và vị trí ảnh phù hợp giúp cải thiện trải nghiệm người dùng rõ rệt.',
            'Tương thích mạng xã hội: nhiều nền tảng có giới hạn kích thước ảnh, công cụ giúp bạn đáp ứng đúng chuẩn.',
            'Hỗ trợ thiết kế responsive: nhà phát triển cần nhiều kích thước ảnh khác nhau cho các thiết bị khác nhau.',
            'Lựa chọn tốt hơn: thay vì kéo giãn hoặc cắt quá mạnh làm méo ảnh, đổi kích thước thường cho kết quả tốt hơn.',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. Định dạng được hỗ trợ: công cụ của chúng tôi hỗ trợ chọn ảnh ở mọi định dạng. Danh sách định dạng hỗ trợ như sau:',
          tocLabel: '5. Định dạng được hỗ trợ',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: 'Cắt Ảnh — Cắt JPG, PNG, GIF Miễn Phí | photremium.com',
      uploadDesc: 'Cắt ảnh JPG, PNG và GIF dễ dàng miễn phí trực tuyến.',
      uploadKeywords: 'cắt ảnh, công cụ cắt ảnh, cắt jpg, cắt png',
      workspaceTitle: 'Đang Cắt Ảnh — photremium.com',
      workspaceDesc: 'Cắt ảnh miễn phí trực tuyến.',
      workspaceKeywords: 'cắt ảnh, công cụ cắt',
    },
    title: 'Cắt Ảnh',
    desc: 'Cắt JPG, PNG, GIF và nhiều hơn nữa với trình chỉnh sửa trực quan. Tỷ lệ đặt sẵn hoặc cắt tự do.',
    toCrop: 'để cắt',
    cropSettings: 'Cài Đặt Cắt',
    widthPx: 'Chiều Rộng (px)',
    heightPx: 'Chiều Cao (px)',
    positionX: 'Vị Trí X (px)',
    positionY: 'Vị Trí Y (px)',
    cropTemplate: 'Mẫu Cắt',
    landscape: 'Ngang',
    portrait: 'Dọc',
    square: 'Vuông',
    freeform: 'Tự Do',
    cropping: 'Đang cắt…',
    cropDownload: 'Cắt & Tải Về',
    cropDownloadAll: 'Cắt & Tải Tất Cả',
    saveNext: 'Lưu & Tiếp Theo',
    croppedNofTotal: 'Đã cắt {n} trong {total} ảnh.',
    downloadN: 'Tải {n} Ảnh',
    blog: {
      tocTitle: 'Mục lục',
      title: 'Blog Công Cụ Cắt Ảnh',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. Tại sao nên dùng công cụ cắt ảnh?',
          paragraphs: [
            'Công cụ cắt ảnh là một công cụ phần mềm dùng để cắt ảnh theo hình dạng mong muốn. Nó được dùng rộng rãi để giữ lại phần ảnh cần thiết và loại bỏ phần bên ngoài không mong muốn cho bất kỳ mục đích nào. Công cụ cung cấp một khung cắt mà bạn có thể điều chỉnh tại vị trí muốn cắt.',
          ],
          listTitle: 'Ví dụ:',
          bullets: [
            'Cắt riêng bạn ra khỏi ảnh nhóm.',
            'Cắt tên của bạn ra khỏi danh sách.',
            'Cắt thanh tiến trình từ ảnh chụp màn hình toàn màn hình.',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. Vì sao chọn công cụ cắt ảnh của chúng tôi?',
          paragraphs: [
            'Công cụ cắt ảnh của chúng tôi cho phép bạn cắt ảnh chính xác và rất nhanh. Bạn chỉ cần điều chỉnh kích thước khung cắt tại vị trí muốn cắt trên bất kỳ ảnh nào. Gần như mọi định dạng ảnh đều được hỗ trợ khi chọn ảnh.',
          ],
          bullets: [
            'Bạn có thể cắt số lượng ảnh theo khả năng thiết bị của mình. Nếu thiết bị hiệu năng cao, bạn thậm chí có thể cắt 100+ ảnh cùng lúc mà không giật lag hay vấn đề khác.',
            'Ảnh của bạn được xử lý ngay trên trình duyệt cục bộ. Không cần tải ảnh lên máy chủ của chúng tôi, nên không có ảnh nào rời khỏi thiết bị. Bạn có thể cắt ảnh cá nhân mà không lo rủi ro bảo mật.',
            'Nhiều công cụ báo lỗi định dạng ảnh không hợp lệ. Công cụ cắt ảnh của chúng tôi xử lý vấn đề này bằng cách hỗ trợ gần như mọi định dạng ảnh.',
            'Nếu bạn cắt nhiều ảnh cùng lúc, công cụ của chúng tôi cho phép tải ảnh đã cắt dưới dạng ZIP hoặc từng ảnh riêng theo lựa chọn của bạn.',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. Hướng dẫn từng bước',
          steps: [
            {
              heading: '1. Trước hết, chọn ảnh bạn muốn cắt. Công cụ cắt ảnh của chúng tôi cũng hỗ trợ chọn nhiều ảnh cùng lúc.',
              bullets: [
                'Kéo và thả ảnh vào khung thả để cắt.',
                'Bạn cũng có thể chọn ảnh qua trình quản lý tệp bằng cách bấm nút choose files trong khung cắt.',
                'Phím tắt Ctrl + V cũng được hỗ trợ để dán ảnh vào khung thả.',
              ],
            },
            {
              heading: '2. Sau đó, điều chỉnh kích thước và vị trí khung cắt trên ảnh để cắt.',
            },
            {
              heading: '3. Bạn cũng có thể điều chỉnh khung cắt bằng cách nhập thủ công chiều cao, chiều rộng, vị trí ngang và vị trí dọc.',
            },
            {
              heading: '4. Bạn cũng có thể dùng một số mẫu có sẵn:',
              bullets: [
                'Landscape(16:9)',
                'Portrait(9:16)',
                'Square(1:1)',
              ],
            },
            {
              heading: '5. Tiếp theo bạn cần chọn một tùy chọn tải xuống.',
              bullets: [
                'ZIP: Chọn tùy chọn này nếu bạn cắt nhiều ảnh và muốn tải tất cả ảnh đã cắt dưới dạng một tệp.',
                'Separate: Nếu bạn muốn tải tất cả ảnh đã cắt riêng lẻ, hãy chọn tùy chọn này ở nút chuyển.',
              ],
            },
            {
              heading: '6. Sau đó bấm nút Crop & Download để tải tất cả ảnh đã cắt theo kích thước đặt sẵn của bạn.',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. Lợi ích của công cụ cắt ảnh: công cụ cắt ảnh mang lại nhiều lợi ích trong thế giới số. Một số lợi ích được nêu dưới đây:',
          tocLabel: '4. Lợi ích của công cụ cắt ảnh',
          bullets: [
            'Đưa ảnh vào khung chuẩn: Công cụ cắt ảnh giúp bạn đặt ảnh đúng trong khung. Khung này có thể nằm trên trang web hoặc trên bất kỳ nền tảng mạng xã hội nào.',
            'Nâng cao UX: Vì việc đặt ảnh đúng cách giúp tăng trải nghiệm người dùng, công cụ cắt ảnh góp phần cải thiện UX đáng kể.',
            'Loại bỏ viền không mong muốn: Bạn có thể loại bỏ các viền không cần thiết của ảnh để làm ảnh gọn hơn.',
            'Tách đối tượng mong muốn: Bạn cũng có thể tách riêng bản thân khỏi ảnh nhóm.',
            'Tiết kiệm dung lượng: Cắt ảnh giúp tiết kiệm lưu trữ vì vùng thừa bị loại bỏ và chỉ phần cần thiết được giữ lại.',
            'Tối ưu bài thuyết trình: Nếu một bài thuyết trình thông thường với 10 ảnh chưa cắt chiếm khoảng 30MB, thì bài thuyết trình tương tự với ảnh đã cắt có thể chỉ còn khoảng 10MB.',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. Định dạng được hỗ trợ:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: 'Chỉnh Sửa Ảnh Trực Tuyến — Chỉnh Sửa Miễn Phí với Văn Bản, Hiệu Ứng, Khung | photremium.com',
      desc: 'Chỉnh sửa ảnh trực tuyến miễn phí — thêm văn bản, hiệu ứng, khung, nhãn dán. Chạy trong trình duyệt.',
      keywords: 'chỉnh sửa ảnh, chỉnh sửa ảnh trực tuyến, chỉnh sửa ảnh miễn phí',
    },
    title: 'Chỉnh Sửa Ảnh',
    desc: 'Trang trí ảnh của bạn với văn bản, hiệu ứng, khung và nhãn dán.',
    toEdit: 'để chỉnh sửa',
    textTypography: 'Văn Bản & Kiểu Chữ',
    textTypographyDesc: 'Thêm văn bản với nhiều phông chữ, màu sắc, bóng và tùy chọn vị trí.',
    filtersEffects: 'Bộ Lọc & Hiệu Ứng',
    filtersEffectsDesc: 'Áp dụng bộ lọc chuyên nghiệp và điều chỉnh độ sáng, độ tương phản và độ bão hòa.',
    framesStickers: 'Khung & Nhãn Dán',
    framesStickersDesc: 'Chọn khung đẹp và nhãn dán vui nhộn để làm đẹp thêm ảnh của bạn.',
  },

  removeBg: {
    seo: {
      uploadTitle: 'Xóa Nền Ảnh Miễn Phí | photremium.com',
      uploadDesc: 'Xóa nền ảnh nhanh chóng với độ chính xác cao. Công cụ xóa nền miễn phí trực tuyến.',
      uploadKeywords: 'xóa nền, xóa nền ảnh, nền trong suốt',
      workspaceTitle: 'Đang Xóa Nền — photremium.com',
      workspaceDesc: 'Xóa nền ảnh miễn phí trực tuyến.',
      workspaceKeywords: 'xóa nền, nền trong suốt',
    },
    title: 'Xóa Nền',
    desc: 'Xóa nền ảnh ngay lập tức với công nghệ phát hiện cạnh tiên tiến. 100% miễn phí, chạy trên trình duyệt.',
    toRemoveBg: 'để xóa nền',
    backgroundRemover: 'Công Cụ Xóa Nền',
    processingProgress: 'Tiến Độ Xử Lý',
    processingNImages: 'Đang xử lý {n} ảnh…',
    allNProcessed: 'Tất cả {n} ảnh đã được xử lý!',
    nOfTotalDone: '{n} / {total} hoàn thành',
    fileName: 'Tên File',
    dimensions: 'Kích Thước',
    status: 'Trạng Thái',
    statusDone: '✓ Hoàn Thành',
    statusProcessing: '⏳ Đang Xử Lý',
    statusError: '✗ Lỗi',
    statusPending: '⏸ Chờ Xử Lý',
    badgeDone: 'Xong',
    badgeProcessing: 'Đang xử lý…',
    badgeError: 'Lỗi',
    removingBg: 'Đang xóa nền…',
    retry: 'Thử Lại',
    downloading: 'Đang tải về…',
    nextImage: 'Ảnh Tiếp Theo',
  },

  watermark: {
    seo: {
      uploadTitle: 'Thêm Hình Mờ — Thêm Văn Bản và Logo Miễn Phí | photremium.com',
      uploadDesc: 'Thêm hình mờ văn bản hoặc ảnh vào ảnh trong vài giây. Miễn phí, nhanh chóng.',
      uploadKeywords: 'thêm hình mờ, hình mờ ảnh, hình mờ văn bản',
      workspaceTitle: 'Thêm Hình Mờ Ảnh — photremium.com',
      workspaceDesc: 'Thêm hình mờ vào ảnh miễn phí trực tuyến.',
      workspaceKeywords: 'thêm hình mờ, hình mờ ảnh',
    },
    title: 'Thêm Hình Mờ Ảnh',
    desc: 'Thêm hình mờ văn bản hoặc logo vào ảnh. Tùy chỉnh phông chữ, độ mờ, kích thước và vị trí.',
    toWatermark: 'để thêm hình mờ',
    watermarkTools: 'Công Cụ Hình Mờ',
    addText: 'Thêm Văn Bản',
    addImage: 'Thêm Ảnh',
    layersN: 'Lớp ({n})',
    noLayers: 'Chưa có lớp nào được thêm',
    textLayer: 'Lớp Văn Bản',
    imageLayer: 'Lớp Ảnh',
    watermarkDownloadAll: 'Thêm Hình Mờ & Tải Tất Cả',
    watermarkDownload: 'Thêm Hình Mờ & Tải Về',
    nextImage: 'Ảnh Tiếp Theo',
    bold: 'In Đậm',
    italic: 'In Nghiêng',
    underline: 'Gạch Chân',
    bgColor: 'Màu Nền',
    textColor: 'Màu Chữ',
    alignLeft: 'Căn Trái',
    alignCenter: 'Căn Giữa',
    alignRight: 'Căn Phải',
    opacity: 'Độ Mờ',
    stroke: 'Viền',
    strokeWidth: 'Độ Dày Viền',
    strokeColor: 'Màu Viền',
    tileRepeat: 'Lặp/Xếp Lớp',
    tilePattern: 'Kiểu Lặp',
    spacing: 'Khoảng Cách',
    snapToCenter: 'Căn Giữa',
    duplicate: 'Nhân Bản',
    delete: 'Xóa',
    flipHorizontal: 'Lật Ngang',
    flipVertical: 'Lật Dọc',
    rotateLeft: 'Xoay Trái',
    rotateRight: 'Xoay Phải',
    cornerRadius: 'Bán Kính Góc',
    borderStroke: 'Đường Viền',
    borderWidth: 'Độ Dày Viền',
    color: 'Màu Sắc',
    style: 'Kiểu Dáng',
    hide: 'Ẩn',
    show: 'Hiện',
    lock: 'Khóa',
    unlock: 'Mở Khóa',
    solid: 'Liền',
    dashed: 'Nét Đứt',
    dotted: 'Chấm',
    double: 'Đôi',
    tileSingle: 'Đơn',
    tile2x2: 'Lưới 2×2',
    tile3x3: 'Lưới 3×3',
    removeAllConfirm: 'Xóa tất cả ảnh và hình mờ?',
    dimMismatch: 'Ảnh tải lên có kích thước khác nhau. Để có kết quả tốt nhất, hãy tải ảnh có cùng độ phân giải.',
    clearBackground: 'Xóa Nền',
    typeHere: 'Nhập ở đây...',
    linkCorners: 'Liên Kết Góc',
    separateCorners: 'Tách Góc',
    blog: {
      tocTitle: 'Mục lục',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'Tổng quan công cụ hình mờ',
          title: 'Cách thêm hình mờ vào ảnh online — Hướng dẫn đầy đủ về công cụ Hình Mờ của Photremium',
          paragraphs: [
            'Bạn vừa hoàn tất chỉnh sửa một bức ảnh đẹp. Có thể đó là ảnh sản phẩm cho cửa hàng, chân dung từ buổi chụp với khách, hoặc tác phẩm nghệ thuật số bạn đã dày công hoàn thiện. Và rồi câu hỏi mà mọi người sáng tạo đều gặp phải xuất hiện: làm sao bảo vệ nó trước khi chia sẻ?',
            'Câu trả lời của hầu hết chuyên gia là: hình mờ — và hoàn toàn có lý. Hình mờ được đặt đúng vị trí sẽ hoạt động như chữ ký vĩnh viễn, giúp tác phẩm có thể truy vết, gắn thương hiệu và khó bị đánh cắp hơn nhiều.',
            'Vấn đề là: nhiều công cụ online hoặc quá rườm rà, bị khóa sau gói đăng ký, hoặc tạo ra hình mờ quá nặng khiến ảnh bị hỏng hoàn toàn.',
            'Công cụ Hình Mờ của Photremium được tạo ra để giải quyết tất cả những điều đó. Đây là một không gian làm việc gắn hình mờ hoàn toàn chạy trên trình duyệt, miễn phí, không cần tài khoản và không bao giờ tải file lên máy chủ. Mọi thứ đều chạy cục bộ, rất nhanh, và mức độ kiểm soát sáng tạo có thể sánh ngang phần mềm desktop. Trong hướng dẫn này, chúng tôi sẽ cho bạn thấy cách công cụ hoạt động, dành cho ai và cách để luôn có kết quả tốt nhất.',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'Hình mờ là gì',
          title: 'Hình mờ là gì và tại sao quan trọng?',
          paragraphs: [
            'Trước khi đi sâu vào công cụ, hãy hiểu hình mờ làm gì và vì sao nhiều nhiếp ảnh gia, nhà thiết kế và nhà sáng tạo nội dung coi nó là điều không thể thiếu.',
            'Hình mờ là lớp phủ hiển thị trên ảnh — thường là văn bản, logo hoặc ký hiệu bản quyền — dùng để nhận diện người tạo hoặc chủ sở hữu nội dung. Khác với metadata (ẩn trong file và có thể bị gỡ trong vài giây), hình mờ được nhúng trực quan vào ảnh. Bạn không thể chỉ bấm chuột phải để xóa nó mà không làm giảm rõ rệt chất lượng hình ảnh.',
          ],
          subSections: [
            {
              title: 'Vì sao người sáng tạo dùng hình mờ',
              paragraphs: [
                'Những lý do thực tế để gắn hình mờ thường quy về ba điểm cốt lõi.',
              ],
              bullets: [
                'Xác định quyền sở hữu. Khi tác phẩm của bạn được chia sẻ trên mạng xã hội, bảng Pinterest hoặc nhúng vào bài blog, phần ghi công gốc thường bị mất. Hình mờ đảm bảo tên hoặc thương hiệu của bạn đi kèm theo ảnh ở bất cứ đâu.',
                'Ngăn chặn đánh cắp. Hầu hết kẻ lấy ảnh trái phép chọn con đường dễ nhất. Một hình mờ trông chuyên nghiệp, đặt đúng chỗ và hơi trong suốt gửi đi tín hiệu rõ ràng: ảnh này thuộc về người bảo vệ tác phẩm của mình.',
                'Bảo vệ portfolio cho khách. Các nhiếp ảnh gia thường gửi bản xem trước cho khách trước khi thanh toán cuối cùng và dùng hình mờ để tránh việc bị sử dụng mà chưa thanh toán. Hình mờ tinh tế giúp bảo vệ mà không gây khó đánh giá.',
              ],
            },
            {
              title: 'Ai nên gắn hình mờ cho ảnh',
              paragraphs: [
                'Nếu bạn thuộc một trong các nhóm sau, việc gắn hình mờ trước khi chia sẻ online không phải lựa chọn — mà là điều cần thiết:',
              ],
              bullets: [
                'Nhiếp ảnh gia freelance chia sẻ album với khách hàng',
                'Nhà thiết kế đồ họa phát hành mẫu portfolio',
                'Người bán e-commerce hiển thị ảnh sản phẩm trước khi ký thỏa thuận cấp phép',
                'Nghệ sĩ số chia sẻ tác phẩm trên nền tảng xã hội',
                'Blogger và creator có ảnh bị tái sử dụng thường xuyên',
                'Cộng tác viên ảnh stock xây dựng thương hiệu nhận diện',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'Bảng điều khiển không gian làm việc',
          title: 'Bên trong công cụ Hình Mờ Photremium: không gian làm việc ba bảng cho quy trình thực tế',
          paragraphs: [
            'Điều làm công cụ hình mờ của Photremium khác biệt với các công cụ cơ bản online là thiết kế không gian làm việc. Thay vì chỉ “nhập chữ, chọn vị trí, xong”, công cụ cung cấp bố cục ba bảng giống phần mềm thiết kế chuyên nghiệp — nhưng chạy hoàn toàn trong trình duyệt, không cần cài đặt.',
          ],
          subSections: [
            {
              title: 'Bảng canvas bên trái',
              paragraphs: [
                'Bảng canvas chiếm phần lớn màn hình và hiển thị chính xác hình ảnh của bạn với hình mờ theo thời gian thực. Mọi thay đổi — chỉnh độ mờ, kéo vị trí chữ, thay kích thước logo — đều cập nhật ngay trên canvas. Không có nút “preview”. Bạn thấy gì là kết quả đó.',
                'Canvas có thanh công cụ zoom tích hợp, giúp phóng to để căn chính xác và thu nhỏ để nhìn tổng thể. Tính năng zoom-to-fit tự động tính tỉ lệ ban đầu tốt nhất dựa trên kích thước màn hình để ảnh độ phân giải cao vẫn dễ làm việc. Các đường dẫn căn chỉnh xuất hiện khi bạn kéo lớp gần tâm ngang hoặc dọc, giúp khóa hình mờ vào chính giữa với độ chính xác mà bạn thường chỉ thấy ở Photoshop.',
              ],
            },
            {
              title: 'Bảng cài đặt bên phải',
              paragraphs: [
                'Bảng bên phải là trung tâm điều khiển. Đây là nơi bạn quản lý các lớp hình mờ, tùy chỉnh diện mạo và kích hoạt xuất cuối. Trên desktop, bảng cố định bên phải. Trên mobile, bảng trượt lên như bottom sheet — mở bằng nút bánh răng nổi — nên không che canvas khi bạn làm việc.',
                'Trong bảng bên phải có trình quản lý lớp, liệt kê mọi phần tử hình mờ bạn đã thêm. Mỗi mục hiển thị loại lớp (văn bản hoặc ảnh), tên hoặc nội dung và ba nút nhanh: bật/tắt hiển thị (biểu tượng mắt), khóa vị trí và xóa.',
              ],
            },
            {
              title: 'Dải xem trước bên trái (chế độ nhiều ảnh)',
              paragraphs: [
                'Khi bạn làm việc với nhiều ảnh cùng lúc — ví dụ một lô ảnh sản phẩm hoặc cả buổi chụp chân dung — một dải thumbnail dọc xuất hiện ở mép trái màn hình. Đây là hàng đợi ảnh, hiển thị bản xem trước của mọi file đã tải. Nhấp vào bất kỳ thumbnail nào để chuyển canvas sang ảnh đó ngay lập tức, giúp bạn kiểm tra hình mờ trên các bố cục khác nhau mà không mất thiết lập lớp.',
                'Dải này cũng hiển thị dung lượng file theo KB hoặc MB và định dạng (JPG, PNG, WEBP) để bạn luôn biết mình đang xử lý gì chỉ trong một cái nhìn.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'Từng bước',
          title: 'Từng bước: cách thêm hình mờ trên Photremium',
          paragraphs: [
            'Hướng dẫn này dựa trực tiếp trên cách công cụ hoạt động — từ hệ thống upload kéo-thả đến engine render trên canvas ghi hình mờ vĩnh viễn vào ảnh trước khi tải về.',
          ],
          steps: [
            {
              heading: 'Bước 1 — Tải ảnh lên',
              paragraphsBefore: [
                'Truy cập photremium.com/watermark-image. Bạn sẽ vào màn hình upload với khu vực dropzone sạch ở giữa trang.',
                'Bạn có ba cách đưa ảnh vào công cụ:',
              ],
              bullets: [
                'Drag and drop. Kéo một hoặc nhiều file ảnh từ desktop vào dropzone. Công cụ hỗ trợ các định dạng phổ biến — JPEG, PNG, WEBP, và nhiều hơn. Khi kéo file vào khu vực làm việc, một viền tím xuất hiện kèm thông báo “Drop images to add for watermarking” để báo nhận drop.',
                'Click to browse. Nhấp nút “Choose Files” trong dropzone để mở trình chọn file. Bạn có thể chọn nhiều file cùng lúc bằng Ctrl+Click (Windows) hoặc Cmd+Click (Mac).',
                'Paste from clipboard. Nếu bạn đã sao chép ảnh vào clipboard — từ screenshot, ứng dụng khác, hoặc trình duyệt — chỉ cần nhấn Ctrl+V (hoặc Cmd+V trên Mac) trên trang watermark là ảnh sẽ được tải trực tiếp vào workspace. Cách này vẫn hoạt động khi đã có nhiều ảnh được tải.',
              ],
              paragraphsAfter: [
                'Khi ảnh đầu tiên được tải, workspace chuyển từ màn hình upload sang trình chỉnh sửa ba bảng đầy đủ và canvas hiển thị ảnh với mức zoom fit-to-screen được tính tự động.',
              ],
            },
            {
              heading: 'Bước 2 — Thêm lớp hình mờ văn bản',
              paragraphsBefore: [
                'Nhấp nút màu tím “Add Text” ở bảng bên phải. Một lớp văn bản mới xuất hiện trên canvas với placeholder “Type here...” đã được chọn sẵn.',
                'Bạn có thể gõ ngay lập tức. Văn bản được render trực tiếp trên canvas bằng Arial trắng với kích thước mặc định phù hợp với ảnh. Từ thanh công cụ phía trên (xuất hiện khi lớp văn bản được chọn), bạn có thể tùy chỉnh mọi chi tiết của chữ:',
              ],
              bullets: [
                'Font family — chọn từ 12 font tích hợp gồm Arial, Georgia, Impact, Brush Script MT, Comic Sans MS và nhiều font khác',
                'Font size — nhập giá trị pixel tùy chỉnh hoặc dùng điều khiển tăng/giảm',
                'Bold, italic, underline — bật bất kỳ комбинация kiểu nào',
                'Text color — nhấp ô màu để mở bộ chọn màu và chọn bất kỳ màu hex nào',
                'Background color — thêm nền màu sau chữ để tạo kiểu nhãn/badge',
                'Stroke (outline) — đặt độ dày và màu viền để chữ dễ đọc trên nền sáng/tối',
                'Opacity — kéo từ 0% (ẩn) đến 100% (hiện rõ); đa số hình mờ nằm trong khoảng 30%–60%',
                'Alignment — căn trái, giữa hoặc phải trong hộp chữ',
                'Rotation — xoay lớp chữ ở bất kỳ góc nào, có điểm snap tại 0°, 90°, 180° và 270° để đặt nhanh',
              ],
              paragraphsAfter: [
                'Để di chuyển chữ, nhấp và kéo đến vị trí mong muốn trên canvas. Để căn chỉnh chính xác từng pixel, dùng phím mũi tên (giữ Shift để di chuyển 10 px). Để thay đổi kích thước hộp chữ, kéo một trong tám tay nắm (góc và cạnh) quanh lớp được chọn.',
              ],
            },
            {
              heading: 'Bước 3 — Thêm lớp hình mờ ảnh (logo)',
              paragraphsBefore: [
                'Nếu bạn muốn dùng logo, chữ ký hoặc ảnh làm hình mờ thay vì — hoặc cùng với — chữ, nhấp nút màu xanh “Add Image” ở bảng bên phải. Trình chọn file mở ra để bạn chọn ảnh hình mờ từ thiết bị.',
                'Công cụ tự động đặt kích thước ảnh hình mờ khoảng 30% chiều rộng canvas, giữ nguyên tỉ lệ và căn giữa. Bạn có thể kéo đến bất kỳ vị trí nào, thay đổi kích thước bằng tay nắm góc (giữ tỉ lệ) hoặc xoay bằng tay nắm xoay phía trên lớp đã chọn.',
                'Với lớp hình mờ dạng ảnh, bảng bên phải có thêm các điều khiển:',
              ],
              bullets: [
                'Opacity — giống lớp chữ, lý tưởng cho logo PNG trong suốt',
                'Flip horizontal / Flip vertical — lật gương hình mờ khi cần',
                'Border width, border color, and border style — thêm viền nhìn thấy quanh logo',
                'Border radius — bo tròn các góc logo, đồng đều hoặc tách từng góc',
                'Rotation — hành vi xoay mượt giống lớp chữ',
              ],
            },
            {
              heading: 'Bước 4 — Cấu hình lặp (tùy chọn)',
              paragraphsBefore: [
                'Một tính năng mạnh là lặp (tiling) — khả năng lặp hình mờ phủ khắp ảnh theo dạng lưới. Điều này đặc biệt hữu ích nếu bạn muốn làm ảnh khó bị tái sử dụng chứ không chỉ gắn nhãn.',
                'Khi chọn một lớp, hãy tìm tùy chọn tile trên toolbar. Bạn có thể đặt thành:',
              ],
              bullets: [
                'None — đặt một lần (mặc định)',
                'Grid 2×2 — lặp theo lưới 2 cột, 2 hàng',
                'Grid 3×3 — lặp theo lưới 3×3 để phủ dày hơn',
              ],
              paragraphsAfter: [
                'Bạn cũng có thể điều chỉnh khoảng cách lặp, kiểm soát khoảng trống giữa mỗi bản sao. Canvas hiển thị bản xem trước mờ của tất cả bản sao để bạn thấy toàn bộ mẫu phủ trước khi tải xuống.',
              ],
            },
            {
              heading: 'Bước 5 — Dùng trình quản lý lớp cho nhiều hình mờ',
              paragraphsBefore: [
                'Bạn có thể thêm bao nhiêu lớp tùy ý — trộn văn bản và hình ảnh. Trình quản lý lớp ở bảng bên phải liệt kê tất cả. Bạn có thể:',
              ],
              bullets: [
                'Hiện/ẩn từng lớp bằng biểu tượng mắt — hữu ích để chuyển giữa các phiên bản hình mờ mà không xóa',
                'Khóa một lớp để tránh bị dịch chuyển khi làm việc với lớp khác',
                'Xóa một lớp vĩnh viễn',
              ],
              paragraphsAfter: [
                'Nhấp bất kỳ mục nào trong danh sách sẽ chọn lớp tương ứng trên canvas, giúp bạn chuyển nhanh giữa các lớp mà không phải tìm trên ảnh.',
              ],
            },
            {
              heading: 'Bước 6 — Chuyển giữa nhiều ảnh',
              paragraphsBefore: [
                'Nếu bạn tải lên nhiều hơn một ảnh, dùng dải thumbnail bên trái để chuyển ảnh đang chỉnh trên canvas. Các lớp hình mờ bạn cấu hình sẽ áp dụng đồng loạt — chúng sẽ được render lên mọi ảnh trong lô khi xuất.',
                'Công cụ cũng kiểm tra tính nhất quán độ phân giải trong lô. Nếu ảnh có kích thước khác biệt đáng kể (hơn 5% về chiều rộng hoặc chiều cao), sẽ có cảnh báo rằng vị trí hình mờ có thể khác do khác kích thước. Engine xử lý bằng thuật toán tái định vị theo tỷ lệ: tính vị trí hình mờ theo phần trăm kích thước ảnh tham chiếu và áp dụng tỷ lệ đó cho mọi ảnh khác, giữ được ý đồ thị giác ngay cả khi khác độ phân giải.',
              ],
            },
            {
              heading: 'Bước 7 — Thiết lập tùy chọn tải xuống',
              paragraphsBefore: [
                'Với ảnh đơn, nhấp nút “Download” dưới canvas để lưu ảnh có hình mờ. Tên file sẽ tự động thêm “-watermarked” trước phần mở rộng. Ảnh JPEG được xuất ở chất lượng 0.95 — đủ cao để khó phân biệt với ảnh gốc ở kích thước xem bình thường. PNG được xuất dạng lossless PNG.',
                'Với lô ảnh (nhiều ảnh), bạn có hai chế độ tải xuống trong bảng bên phải:',
              ],
              bullets: [
                'ZIP file — tất cả ảnh có hình mờ được đóng gói trong một file ZIP tải một lần. Công cụ tải JSZip động để xử lý nén.',
                'Separate files — mỗi ảnh được tải thành file riêng với một khoảng trễ nhỏ giữa các lần tải để tránh trình duyệt hạn chế.',
              ],
            },
            {
              heading: 'Bước 8 — Tải xuống và kiểm tra',
              paragraphsBefore: [
                'Sau khi nhấp nút tải xuống (hoặc “Watermark & Download All” cho lô), công cụ render từng ảnh trên một canvas HTML5 ẩn ở độ phân giải gốc — không phải kích thước xem trước trên màn hình. Điều này nghĩa là ảnh xuất giữ 100% kích thước pixel gốc với hình mờ được vẽ đúng tỷ lệ. Mở file đã tải và zoom để kiểm tra vị trí và chất lượng hình mờ có đúng mong đợi hay không.',
                'Nếu thấy chưa ổn, chỉ cần quay lại workspace — các lớp vẫn còn — chỉnh lại và tải xuống lại.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'Mẹo chuyên nghiệp',
          title: 'Mẹo chuyên nghiệp để có kết quả tốt nhất',
          bullets: [
            'Hãy dùng logo PNG bán trong suốt để tạo cảm giác chuyên nghiệp. Logo nền trong suốt với 40–50% độ mờ trông chỉn chu hơn nhiều so với chữ đặc. Hãy xuất logo từ phần mềm thiết kế dưới dạng PNG có alpha trước khi dùng làm lớp ảnh.',
            'Đặt hình mờ ở vị trí mà cắt xén sẽ làm giảm giá trị. Góc dưới phải là vị trí phổ biến nhất — và cũng dễ bị cắt nhất. Muốn bảo vệ tốt hơn, hãy đặt lên vùng quan trọng như khuôn mặt, chi tiết sản phẩm hoặc điểm nhấn. Tùy chọn tile chéo khó gỡ hơn mà không làm giảm chất lượng ảnh.',
            'Dùng tính năng khóa khi làm với nhiều lớp. Khi đã hài lòng vị trí hình mờ chính, hãy khóa nó trước khi thêm các lớp phụ để tránh bị đẩy lệch.',
            'Kiểm tra trên vùng sáng và tối. Hình mờ trắng sẽ biến mất trên bầu trời sáng nhưng rõ trên vùng tối. Thêm viền mảnh hoặc nền nhẹ để đảm bảo dễ đọc bất kể nội dung bên dưới.',
            'Phím tắt luôn tiết kiệm thời gian. Phím mũi tên di chuyển lớp đang chọn từng 1 pixel. Shift+Arrow di chuyển 10 pixel. Phím Delete xóa ngay lớp đang chọn. Những phím tắt này giúp tinh chỉnh nhanh hơn nhiều so với kéo thả.',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'Quyền riêng tư và bảo mật',
          title: 'Quyền riêng tư và bảo mật: vì sao xử lý trong trình duyệt quan trọng',
          paragraphs: [
            'Một lo ngại phổ biến khi dùng công cụ online là: ảnh của bạn thực sự đi đâu? Với công cụ hình mờ dựa trên server, ảnh sẽ được tải lên máy chủ của nhà cung cấp, xử lý tại đó rồi gửi lại. Điều này có nghĩa là tác phẩm chưa công bố, ảnh khách hàng hoặc ảnh sản phẩm nhạy cảm đi qua hạ tầng của bên thứ ba.',
            'Công cụ hình mờ Photremium xử lý mọi thứ cục bộ trong trình duyệt. Ảnh được nạp vào bộ nhớ thiết bị qua File API của trình duyệt và không bao giờ truyền qua internet. Việc render hình mờ diễn ra trên phần tử canvas HTML5 bằng JavaScript, hoàn toàn trong tab trình duyệt. Khi bạn đóng trang hoặc nhấn “Start Over”, toàn bộ dữ liệu ảnh được giải phóng khỏi bộ nhớ và loại bỏ. Không có gì được lưu bên ngoài thiết bị của bạn.',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'Tóm tắt cuối',
          title: 'Vì sao công cụ Hình Mờ Photremium xứng đáng có chỗ trong quy trình thường xuyên của bạn',
          paragraphs: [
            'Có hàng chục công cụ hình mờ online. Điều phân biệt một công cụ đáng lưu với một công cụ dễ quên thường là sự kết hợp giữa tốc độ, khả năng kiểm soát và độ tin cậy.',
            'Tốc độ quan trọng vì hình mờ không nên làm chậm quy trình hậu kỳ của bạn. Công cụ Photremium tải tức thì, xử lý cục bộ và xuất ở độ phân giải đầy đủ trong vài giây — kể cả với lô lớn. Không phải chờ xử lý server, không có hàng đợi, và không có thời gian render tăng theo số người dùng cùng lúc.',
            'Khả năng kiểm soát quan trọng vì một hình mờ trông sai còn tệ hơn không dùng hình mờ — khiến thương hiệu trông thiếu chuyên nghiệp. Hệ thống lớp, điều khiển theo thuộc tính, preview canvas thời gian thực và hỗ trợ phím tắt tạo nên mức kiểm soát thực sự tương đương phần mềm desktop chuyên dụng.',
            'Độ tin cậy quan trọng vì tác phẩm chưa công bố của bạn rất có giá trị. Biết rằng ảnh của bạn không bao giờ đi qua internet tới server của bên thứ ba nghĩa là bạn có thể gắn hình mờ cho ảnh khách, ảnh sản phẩm chưa phát hành và nội dung sáng tạo nhạy cảm mà không lo về xử lý dữ liệu, rò rỉ server hay thay đổi chính sách của nhà cung cấp cloud.',
            'Dù bạn đang thêm thông báo bản quyền nhanh cho một bức ảnh hay xử lý cả buổi chụp 200 ảnh trước khi chia sẻ album khách, công cụ Hình Mờ Photremium mang đến mọi thứ cần thiết để làm đúng — hoàn toàn miễn phí, hoàn toàn riêng tư, và đủ linh hoạt để hình mờ trông như một phần của ảnh chứ không phải dán lên.',
            'Hãy ghé photremium.com/watermark-image và thử ngay. Ảnh hình mờ đầu tiên của bạn chỉ cách đúng ba mươi giây.',
            'Photremium cung cấp bộ công cụ chỉnh sửa và xử lý ảnh chạy trên trình duyệt. Tất cả công cụ chạy cục bộ — ảnh của bạn luôn ở trên thiết bị của bạn.',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'Tạo Mã QR — Tạo và Tùy Chỉnh Miễn Phí | photremium.com',
      inputDesc: 'Tạo mã QR tùy chỉnh cho URL, văn bản, WiFi, danh bạ, email và Google Maps.',
      inputKeywords: 'tạo mã qr, tạo qr code, mã qr tùy chỉnh',
      customizeTitle: 'Tùy Chỉnh Mã QR — photremium.com',
      customizeDesc: 'Tùy chỉnh kiểu dáng, màu sắc, khung và logo của mã QR. Tải về dạng PNG, JPG, SVG, WEBP hoặc PDF.',
      customizeKeywords: 'tùy chỉnh mã qr, kiểu mã qr',
    },
    title: 'Tạo Mã QR',
    desc: 'Tạo, tùy chỉnh và tải về mã QR cho URL, văn bản, WiFi, danh bạ, email và bản đồ.',
    generate: 'Tạo',
    scanQrCode: 'Quét Mã QR',
    tabUrl: 'Liên Kết / URL',
    tabText: 'Văn Bản',
    tabWifi: 'WiFi',
    tabContact: 'Danh Bạ',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    enterUrl: 'Nhập URL',
    enterText: 'Nhập văn bản',
    networkName: 'Tên Mạng (SSID)',
    password: 'Mật Khẩu',
    encryption: 'Mã Hóa',
    hiddenNetwork: 'Mạng Ẩn',
    contactName: 'Tên Liên Hệ (tùy chọn)',
    phoneNumber: 'Số Điện Thoại',
    emailAddress: 'Địa Chỉ Email',
    subject: 'Tiêu Đề (tùy chọn)',
    body: 'Nội Dung (tùy chọn)',
    searchLocation: 'Tìm kiếm địa điểm',
    urlPlaceholder: 'https://example.com',
    textPlaceholder: 'Nhập văn bản của bạn vào đây…',
    wifiNamePlaceholder: 'WiFi Của Tôi',
    passwordPlaceholder: 'mật khẩu',
    contactPlaceholder: 'Nguyễn Văn A',
    phonePlaceholder: '+84 912 345 678',
    emailPlaceholder: 'example@gmail.com',
    subjectPlaceholder: 'tiêu đề',
    bodyPlaceholder: 'nội dung email…',
    locationPlaceholder: 'Tìm thành phố, địa chỉ, địa điểm…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'Không',
    characters: 'ký tự',
    generateCustomize: 'Tạo & Tùy Chỉnh',
    editQrData: 'Chỉnh Sửa Dữ Liệu QR',
    styleShape: 'Kiểu Dáng & Hình Dạng',
    colorTab: 'Màu Sắc',
    framesTab: 'Khung',
    logoTab: 'Logo',
    templatesTab: 'Mẫu',
    fileFormatTab: 'Định Dạng File',
    fgColor: 'Màu Nền Trước',
    bgColor: 'Màu Nền',
    enableGradient: 'Bật Gradient',
    gradientType: 'Loại Gradient',
    linear: 'Tuyến Tính',
    radial: 'Hướng Tâm',
    selectFrame: 'Chọn Khung',
    selectLogo: 'Chọn Logo',
    uploadCustomLogo: 'hoặc tải lên logo tùy chỉnh',
    uploadImage: 'Tải Ảnh Lên',
    downloadFormat: 'Định Dạng Tải Về',
    preview: 'Xem Trước',
    downloadFormatBtn: 'Tải {format}',
    pngDesc: 'Không mất dữ liệu, hỗ trợ nền trong suốt',
    jpgDesc: 'Định dạng tệp phổ biến/toàn dụng',
    webpDesc: 'Định dạng hiện đại, chất lượng/kích thước tốt nhất',
    svgDesc: 'Đồ họa vector có thể mở rộng',
    pdfDesc: 'Tài liệu sẵn sàng để in',
    lat: 'Vĩ Độ:',
    lng: 'Kinh Độ:',
    qrCode: 'Mã QR',
    scanMe: 'Quét Tôi',
    scanHere: 'Quét Tại Đây',
    blog: {
      card1: {
        title: '1. Mã QR là gì?',
        intro1: 'Hình thức đầy đủ của mã QR là "Quick Response code" (mã phản ứng nhanh). Vì thông tin được lưu trữ trong đó được giải mã rất nhanh, nên gọi nó là mã Quick Response (QR).',
        intro2: 'Mã QR là một mã số hai chiều chỉ có thể đọc bằng máy. Dữ liệu trong nó không thể được con người đọc được. Nó chứa các ô để lưu trữ thông tin như văn bản, số điện thoại, liên kết và vị trí bản đồ Google, v.v.',
        inventionTitle: 'Mã QR được phát minh như thế nào:',
        inventionText: 'Mã QR được phát minh vào năm 1994. Masahiro Hara và nhóm của ông làm việc tại một công ty Nhật Bản tên là Denso Wave, công ty này sản xuất các bộ phận ô tô cho Toyota. Họ muốn một mã có thể lưu trữ nhiều thông tin hơn so với mã vạch thông thường, và như vậy họ đã phát minh ra mã QR.',
        keyFeaturesTitle: 'Các tính năng chính của mã QR',
        keyFeatures: [
          {
            title: 'Mã QR hoạt động như thế nào',
            text: 'Bạn nhập văn bản hoặc liên kết để tạo mã QR. Trình tạo QR tạo các ô vuông theo thông tin. Mỗi ô đại diện cho một bit, và mỗi bit lưu trữ một ký tự.',
          },
          {
            title: 'Cấu trúc của mã QR',
            text: 'Mã QR chứa ba ô vuông lớn để xác định hướng của mã QR và một ô vuông nhỏ để lưu trữ các bit (thông tin).',
          },
          {
            title: 'Dung lượng dữ liệu của mã QR',
            text: 'Thường thì mã QR lưu trữ nhiều thông tin hơn mã vạch. Mã QR về cơ bản là phiên bản nâng cao của mã vạch. Nó về cơ bản là mã vạch hai chiều. Mã QR lưu trữ gần 200 ký tự. Nó cũng có thể lưu trữ 400 ký tự, nhưng có thể khó quét được. Lưu trữ hơn 400 ký tự có thể khiến mã QR trở nên rất phức tạp, gần như không thể quét được.',
          },
          {
            title: 'Phát hiện lỗi trong các mã QR',
            text: 'Mã QR vẫn có thể được quét nếu một phần thông tin bị xước hoặc một số bit bị thay đổi. Mã QR sử dụng kỹ thuật phát hiện lỗi Reed-Solomon để phát hiện các lỗi và sửa chúng sau khi được xác định.',
          },
        ],
        errorTitle: 'Mức sửa lỗi của mã QR:',
        errorIntro: 'Các kỹ thuật phát hiện lỗi và sửa lỗi khác nhau được sử dụng trong các trường hợp khác nhau, như mô tả dưới đây:',
        errorHeaders: {
          level: 'Mức Độ',
          recovery: 'Khả năng khôi phục',
          bestUse: 'Trường hợp sử dụng tốt nhất',
        },
        errorRows: [
          {
            level: 'Thấp (L)',
            recovery: '~7%',
            useCases: [
              'Kỹ thuật sửa lỗi này được sử dụng khi mã QR được hiển thị trên màn hình kỹ thuật số, các trang web hoặc trong môi trường sạch.',
              'Khi mã QR được tạo cho thông tin nhỏ, chẳng hạn như Gmail, số liên hệ hoặc văn bản nhỏ.',
            ],
          },
          {
            level: 'Trung Bình (M)',
            recovery: '~15%',
            useCases: [
              'Dành cho tờ rơi và áp phích được cài đặt trong môi trường sạch khi rủi ro hư hại là tối thiểu.',
            ],
          },
          {
            level: 'Tứ phân vị (Q)',
            recovery: '~25%',
            useCases: [
              'Khi mã QR sẽ được cài đặt trong môi trường khắc nghiệt, chẳng hạn như nhà máy/ngoài trời.',
              'Ngoài ra, khi cần một logo nhỏ ở giữa, nó che phủ một vài bit. Do đó, kỹ thuật sửa lỗi này là cần thiết.',
            ],
          },
          {
            level: 'Cao (H)',
            recovery: '~30%',
            useCases: [
              'Được sử dụng khi có khả năng hư hại lớn cho mã QR.',
              'Khi logo lớn che phủ tâm của mã QR.',
              'Ngoài ra, khi cần kiểu dáng nâng cao cho mã QR.',
            ],
          },
        ],
      },
      card2: {
        title: '2. Tại sao chọn trình tạo mã QR của chúng tôi?',
        intro: 'Trình tạo mã QR của chúng tôi giúp tạo mã QR cực kỳ nhanh chóng, an toàn và dễ dàng. Bạn có thể tùy chỉnh mã của mình để làm cho nó nâng cao, chuyên nghiệp và phù hợp với chủ đề của công ty bạn. Tất cả các tùy chỉnh, từ tô màu mã QR đến cài đặt logo trong mã QR, đều được cung cấp miễn phí mãi mãi.',
        strengths: [
          {
            title: 'Tùy chỉnh chuyên nghiệp:',
            text: 'Bạn có thể tạo và tùy chỉnh bao nhiêu mã QR tùy thích mà không có bất kỳ chi phí nào. Tất cả các tính năng hoàn toàn miễn phí. Bạn có thể áp dụng màu gradien, các hình dạng khác nhau cho các ô vuông, logo tùy chỉnh và nhiều tính năng khác.',
          },
          {
            title: 'Hỗ trợ nhiều định dạng:',
            text: 'Trình tạo mã QR của chúng tôi cung cấp nhiều định dạng tải xuống để tiện lợi của bạn. Chỉ cần chọn định dạng ưa thích của bạn trước khi tải xuống. Hiện tại chúng tôi cung cấp các định dạng này:',
          },
          {
            title: 'Mẫu có sẵn:',
            text: 'Bạn có thể sử dụng các màu gradien có sẵn và khung, giúp mã QR của bạn trở nên chuyên nghiệp.',
          },
          {
            title: 'Hỗ trợ logo tùy chỉnh:',
            text: 'Bạn cũng có thể tải lên logo thương hiệu tùy chỉnh, tự động khớp với tâm của mã QR. Bạn cũng có thể chọn logo từ thư viện logo tích hợp, nơi có hơn 30 logo dostupne.',
          },
          {
            title: 'Xem trước trực tiếp:',
            text: 'Trong khi tùy chỉnh, bạn có thể quan sát tất cả các thay đổi trong bảng xem trước trực tiếp. Các thay đổi này trong bảng xem trước là thời gian thực và thay đổi động.',
          },
          {
            title: 'Chỉ báo quét:',
            text: 'Trong khi chọn màu, các cảnh báo và chỉ báo thích hợp sẽ hướng dẫn bạn nếu bạn chọn màu khó quét.',
          },
        ],
        formatHeaders: {
          srNo: 'Số',
          formats: 'Định dạng',
          description: 'Mô tả',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'Không mất dữ liệu, hỗ trợ trong suốt' },
          { no: '2', format: 'JPG', description: 'Phổ biến, định dạng tệp phổ quát' },
          { no: '3', format: 'WEBP', description: 'Hiện đại, chất lượng/kích thước tốt nhất' },
          { no: '4', format: 'SVG', description: 'Đồ họa vector có thể mở rộng' },
          { no: '5', format: 'PDF', description: 'Tài liệu sẵn sàng để in' },
        ],
      },
      card3: {
        title: '3. Hướng dẫn từng bước:',
        step1Intro: 'Trước tiên, chọn danh mục mã QR mà bạn muốn tạo. Nếu bạn tạo mã QR cho liên hệ, bản đồ, liên kết hoặc văn bản. Hiện tại, trình tạo mã QR của chúng tôi cung cấp các danh mục này:',
        categories: ['Liên Kết / URL', 'Văn Bản', 'WiFi', 'Liên Hệ', 'Gmail', 'Google Maps'],
        step2: 'Sau khi chọn danh mục, dán thông tin của bạn vào trường văn bản.',
        step3Intro: 'Sau đó, bấm vào Tạo & Tùy chỉnh để mở bảng tùy chỉnh. Trong bảng tùy chỉnh, bạn sẽ thấy thanh dưới điều hướng với các tùy chọn sau:',
        options: [
          {
            title: 'Kiểu dáng & Hình dạng:',
            text: 'Trong phần này, bạn có thể thay đổi hình dạng của các ô vuông thành nhiều kiểu khác nhau, chẳng hạn như các góc tròn, dấu chấm, thanh ngang, thanh dọc, hình vuông nhỏ và nhiều hơn nữa.',
          },
          {
            title: 'Màu sắc:',
            text: 'Trong phần này, bạn có thể chọn màu nền và nền trước tùy chỉnh. Để tạo mã QR với màu gradien, bạn có tùy chọn để bật gradien, cho phép bạn áp dụng bất kỳ màu gradien nào từ thư viện tích hợp hoặc dễ dàng tạo màu gradien. Bạn cũng có thể thay đổi góc của màu gradien tuyến tính. Gradient xuyên tâm cũng được hỗ trợ. Bạn có thể thêm nhiều màu để tạo hiệu ứng gradien chuyên nghiệp.',
          },
          {
            title: 'Khung:',
            text: 'Tại đây, bạn có thể chọn khung hoàn hảo cho mã QR của bạn. Tất cả các khung tự động khớp với mã của bạn. Chỉ cần chọn một khung từ thư viện tích hợp.',
          },
          {
            title: 'Logo:',
            text: 'Sau khi chọn khung, bạn có thể chọn logo, sẽ tự động điều chỉnh với tâm của mã QR. Tải lên logo thương hiệu tùy chỉnh cũng được hỗ trợ.',
          },
          {
            title: 'Mẫu:',
            text: 'Nếu bạn không muốn chọn kiểu dáng, hình dạng, màu sắc và khung riêng lẻ, bạn có thể áp dụng các mẫu được thực hiện sẵn cho mã QR. Nhiều mẫu cao cấp có sẵn cho tiện lợi của bạn, miễn phí mãi mãi.',
          },
          {
            title: 'Định dạng tệp:',
            text: 'Cuối cùng, bạn phải chọn loại tệp mà bạn muốn tải xuống mã QR. Hỗ trợ nhiều định dạng phổ biến, bao gồm PNG, WEBP, SVG và PDF, v.v.',
          },
          {
            title: 'Chỉnh sửa Dữ liệu QR:',
            text: 'Bạn cũng có thể chỉnh sửa dữ liệu QR mà không mất bất kỳ tùy chỉnh nào được chọn.',
          },
        ],
        finalStep: 'Sau đó, chỉ cần bấm nút tải xuống và mã QR chính xác theo tùy chỉnh của bạn ở định dạng đã chọn sẽ được tải xuống ngay lập tức mà không có bất kỳ chi phí nào.',
      },
      card4: {
        title: '4. Lợi ích:',
        intro: 'Mã QR kết nối thế giới vật lý với trải nghiệm kỹ thuật số. Đây là cách nhanh nhất để chia sẻ liên kết, danh bạ hoặc vị trí của bạn. Chỉ cần quét mã QR để ngay lập tức truy cập thông tin. Đó là lý do tại sao nó cực kỳ phổ biến trong kinh doanh và thế giới kỹ thuật số, vì nó tiết kiệm thời gian và rất có mục đích.',
        benefits: [
          {
            title: 'Hỗ trợ Trọn đời:',
            text: 'Các mã QR hoạt động mãi mãi mà không có ngày hết hạn. Chúng cung cấp cho bạn thông tin được lưu trữ ngay lập tức khi bạn quét chúng. Vì nó chứa các hướng dẫn kỹ thuật số được mã hóa cố định, nó không bao giờ mất thông tin.',
          },
          {
            title: 'Hỗ trợ offline:',
            text: 'Bạn có thể quét mã QR ngay cả khi bạn ngoại tuyến. Máy ảnh điện thoại di động của bạn giải mã các mẫu mã QR và cung cấp cho bạn thông tin được lưu trữ trong đó.',
          },
          {
            title: 'Chi phí bằng không:',
            text: 'Vì những mã này không yêu cầu bất kỳ chuyển hướng máy chủ hoặc tài nguyên nào, chúng miễn phí mãi mãi.',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'Quét Mã QR — Quét Mã QR Từ Camera hoặc Ảnh | photremium.com',
      desc: 'Quét mã QR ngay lập tức bằng camera hoặc tải ảnh lên. Phát hiện URL, văn bản, WiFi, danh bạ và nhiều hơn nữa.',
      keywords: 'quét mã qr, đọc mã qr, scanner qr, mã qr trực tuyến',
    },
    title: 'Quét Mã QR',
    desc: 'Quét mã QR ngay lập tức bằng camera hoặc tải ảnh lên. Nhanh chóng và an toàn.',
    generateQrCode: 'Tạo Mã QR',
    scan: 'Quét',
    cameraScanner: 'Quét Bằng Camera',
    uploadImage: 'Tải Ảnh Lên',
    pointCamera: 'Hướng camera vào mã QR',
    startCamera: 'Bật Camera',
    loading: 'Đang tải…',
    dropQrImage: 'Thả ảnh mã QR vào đây',
    toScan: 'để quét',
    supportedFormats: 'Hỗ trợ JPG, PNG, GIF, WEBP',
    ctrlVPaste: 'Dán bằng Ctrl+V',
    scanFromGallery: 'Quét Từ Thư Viện',
    instantScanning: 'Quét Tức Thì',
    instantScanningDesc: 'Phát hiện mã QR theo thời gian thực từ camera hoặc ảnh đã tải lên',
    private100: 'Riêng Tư 100%',
    private100Desc: 'Mọi xử lý diễn ra trong trình duyệt của bạn. Không có gì được tải lên',
    multiFormat: 'Đa Định Dạng',
    multiFormatDesc: 'Phát hiện URL, văn bản, WiFi, danh bạ, email, điện thoại và hơn thế nữa',
    accessingCamera: 'Đang truy cập camera…',
    cameraDenied: 'Quyền truy cập camera bị từ chối. Vui lòng cho phép quyền camera và thử lại.',
    noCamera: 'Không tìm thấy camera trên thiết bị này.',
    cameraError: 'Không thể truy cập camera. Vui lòng thử lại.',
    videoError: 'Không thể bắt đầu phát video.',
    switchError: 'Không thể chuyển camera.',
    tryAgain: 'Thử Lại',
    switchCamera: 'Đổi Camera',
    stop: 'Dừng',
    noQrFound: 'Không Tìm Thấy Mã QR',
    couldNotRead: 'Không thể đọc ảnh',
    scannerFailed: 'Tải scanner thất bại',
    noQrFoundDesc: 'Không phát hiện mã QR trong ảnh. Hãy thử ảnh khác hoặc sử dụng camera.',
    qrScanned: 'Mã QR Đã Được Quét!',
    openLink: 'Mở Liên Kết',
    copied: 'Đã Sao Chép!',
    copy: 'Sao Chép',
    share: 'Chia Sẻ',
    scanAgain: 'Quét Lại',
    network: 'Mạng',
    password: 'Mật Khẩu',
    security: 'Bảo Mật',
    unknown: 'Không Xác Định',
    typeText: 'Văn bản',
    typeUrl: 'URL',
    typeWifi: 'Mạng WiFi',
    typeContact: 'Thẻ liên hệ',
    typeEmail: 'Email',
    typePhone: 'Số điện thoại',
    typeSms: 'SMS',
    typeLocation: 'Vị trí',
    blog: {
      tocTitle: 'Nội dung',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. Vì sao nên dùng trình quét mã QR?',
          paragraphs: [
            'Trình quét mã QR về cơ bản là camera di động giải mã thông tin được lưu trong mã QR. Bạn chỉ cần hướng camera vào mã QR; bất kể hướng của mã QR, công cụ sẽ đọc các mẫu cụ thể, phát hiện lỗi, sửa lỗi nếu cần và hiển thị thông tin bên trong.',
          ],
          listTitle: 'Các loại trình quét mã QR:',
          bullets: [
            'Trình quét mã QR trên web: Bạn có thể quét mã QR bằng các trình quét trực tuyến mà trình duyệt của bạn hỗ trợ. Bạn có thể truy cập thông tin qua camera hoặc quét bằng cách tải ảnh lên. Để tự động chuyển hướng và các tính năng nâng cao khác, bạn có thể truy cập https://photremium.com.',
            'Camera di động: Một số điện thoại hiện đại có trình quét mã QR tích hợp trong ứng dụng camera gốc. Chúng có thể lấy và giải mã thông tin chỉ bằng cách quét mã QR qua camera thông thường.',
            'Ứng dụng: Có một số ứng dụng được tạo riêng để quét mã QR. Tuy nhiên, để chuyển hướng nâng cao và nhiều tính năng khác, bạn có thể cài ứng dụng miễn phí qua liên kết này: https://photremium.com.',
            'Thiết bị phần cứng: Một số thiết bị phần cứng cũng được tạo ra để quét mã QR. Các thiết bị này được dùng rộng rãi trong các trung tâm mua sắm lớn để thanh toán sản phẩm.',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. Vì sao chọn trình quét mã QR của chúng tôi?',
          paragraphs: [
            'Bạn có thể khám phá nhiều tính năng nâng cao, từ chuyển hướng đến sao chép nội dung giải mã từ mã QR. Bạn có thể khám phá thêm nhiều tính năng thú vị trong trình quét mã QR của chúng tôi như:',
          ],
          bullets: [
            'Tốc độ nhanh: Trình quét mã QR của chúng tôi giúp giải mã mã QR cực nhanh. Bạn chỉ cần quét mã QR, công cụ của chúng tôi sẽ trả thông tin ngay lập tức với tùy chọn nâng cao để sao chép văn bản/liên kết, mở nếu phát hiện liên kết hoặc tự động lưu nếu phát hiện liên hệ.',
            'Không cần cài đặt: Bạn không cần cài ứng dụng riêng để truy cập trình quét mã QR của chúng tôi. Bạn có thể dùng công cụ này miễn phí qua trình duyệt trên thiết bị của mình.',
            'Truy cập đa nền tảng: Bạn có thể truy cập trên bất kỳ thiết bị nào. Không cần lo về phiên bản hệ điều hành hay yêu cầu khác. Công cụ hỗ trợ mọi phiên bản và mọi thiết bị.',
            'Hỗ trợ mọi định dạng: Tất cả định dạng dữ liệu có thể lưu trong mã QR, bao gồm văn bản thuần, WiFi, URL, danh bạ, Gmail và Google Maps, v.v. đều được công cụ của chúng tôi hỗ trợ.',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. Hướng dẫn từng bước:',
          steps: [
            {
              heading: '1. Trước hết, hãy chọn phương pháp để quét mã QR. Có hai phương pháp sau:',
              subSteps: [
                {
                  heading: 'i. Phương pháp camera',
                  paragraphs: [
                    'Bạn có thể quét mã QR bằng camera thiết bị ngay cả khi đang dùng laptop, PC hoặc bất kỳ thiết bị nào hỗ trợ camera thông thường. Chỉ cần nhấn nút “Start Camera”, một yêu cầu quyền sẽ hiện lên; hãy cho phép trang web này sử dụng camera để quét QR. Nếu bạn lỡ từ chối hoặc yêu cầu quyền không hiển thị, bạn có thể cấp quyền camera thủ công theo các bước sau:',
                  ],
                  notes: [
                    '➔ Với Chrome (Android / Desktop):',
                    '1. Nhấp vào ba dấu chấm',
                    '2. Vào Settings',
                    '3. (Bỏ qua bước này trên Android) Privacy and Security',
                    '4. Nhấp vào Site Settings',
                    '5. Sau đó, trong phần permissions, nhấp Camera',
                    '6. Tìm URL trang web của chúng tôi là https://photremium.com/qr-code-scanner',
                    '7. Cho phép camera từ menu thả xuống.',
                    '➔ Với Safari (iPhone / iOS):',
                    '1. Chạm biểu tượng AA hoặc Website Settings trên thanh địa chỉ.',
                    '2. Chọn Website Settings.',
                    '3. Chạm Camera và chọn Allow.',
                    '4. Nếu vẫn bị chặn: Vào iPhone Settings > Safari > Camera và đặt thành Ask hoặc Allow.',
                  ],
                },
                {
                  heading: 'ii. Phương pháp thư viện',
                  paragraphs: [
                    'Bạn có thể tải ảnh mã QR lên để truy cập thông tin của nó. Nhấp nút “Scan from Gallery”, trình duyệt tệp sẽ mở ra. Sau đó chọn ảnh mã QR. Tất cả định dạng ảnh đều được hỗ trợ như jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz và .xbm, v.v.',
                  ],
                },
              ],
            },
            {
              heading: '2. Khi bạn chọn mã QR, toàn bộ thông tin sẽ hiển thị; cho phép bạn sao chép, chia sẻ hoặc mở liên kết nếu được phát hiện. Bạn cũng có thể quét lại nếu muốn.',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'Lợi ích của trình quét mã QR:.',
          paragraphs: [
            'Trình quét mã QR mang lại nhiều lợi ích trong thế giới số này. Nó giúp thanh toán, xác minh và truy cập thông tin trở nên dễ dàng và nhanh chóng ngay cả khi ngoại tuyến.',
          ],
          bullets: [
            'Truy cập thông tin tức thì: Quét mã QR sẽ cung cấp thông tin chỉ trong vài mili-giây. Công cụ giải mã mẫu, phát hiện lỗi và loại bỏ lỗi rất nhanh, mang lại trải nghiệm cực kỳ nhanh cho người dùng.',
            'Giao tiếp liền mạch: Trong thời đại phát triển này, nhu cầu giao tiếp nhanh và an toàn cho thông tin nhỏ như chi tiết ngân hàng, thông tin sản phẩm, v.v. là rất cấp thiết. Trình quét mã QR giải quyết vấn đề này vì thanh toán được thực hiện bằng cách quét mã QR. Ngoài ra, Google xác minh điện thoại bằng QR khi tạo tài khoản mới trên laptop.',
            'Vé điện tử: Ở bến xe, ga tàu hoặc sân bay, bạn có thể xác minh vé dễ dàng mà không phải chờ lâu trong hàng. Hơn nữa, trình quét mã QR được lắp ở nhiều vị trí tại sân bay để tránh hàng chờ. Điều này cũng giảm nhu cầu nhân sự, từ đó tự động tiết kiệm ngân sách hãng hàng không.',
            'Xác thực sản phẩm: Các thương hiệu cao cấp thường đặt mã QR trên sản phẩm. Khách hàng có thể quét mã đó để kiểm tra tính xác thực của sản phẩm có phải hàng chính hãng hay không.',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: 'Làm Mờ Khuôn Mặt — Làm Mờ Mặt Trong Ảnh Trực Tuyến | photremium.com',
      uploadDesc: 'Tự động phát hiện và làm mờ khuôn mặt trong ảnh bằng AI. Chọn cường độ, hình dạng hoặc emoji.',
      uploadKeywords: 'làm mờ mặt, làm mờ khuôn mặt, nhận diện khuôn mặt, công cụ bảo mật',
      workspaceTitle: 'Công Cụ Làm Mờ Khuôn Mặt — photremium.com',
      workspaceDesc: 'Tự động làm mờ khuôn mặt trong ảnh. 100% miễn phí.',
      workspaceKeywords: 'làm mờ mặt, nhận diện khuôn mặt',
    },
    title: 'Làm Mờ Khuôn Mặt',
    desc: 'Tự động phát hiện và làm mờ khuôn mặt trong ảnh để bảo vệ quyền riêng tư.',
    toBlurFaces: 'để làm mờ khuôn mặt',
    autoDetection: 'Phát Hiện Tự Động',
    autoDetectionDesc: 'AI phát hiện khuôn mặt tìm tất cả khuôn mặt ngay lập tức',
    customBlur: 'Làm Mờ Tùy Chỉnh',
    customBlurDesc: 'Điều chỉnh cường độ, hình dạng và kiểu làm mờ',
    private100: '100% Riêng Tư',
    private100Desc: 'Tất cả xử lý diễn ra cục bộ trên trình duyệt',
    blurTools: 'Công Cụ Làm Mờ',
    faces: 'Khuôn Mặt',
    faceDetection: 'Nhận Diện Khuôn Mặt',
    detecting: 'Đang phát hiện...',
    autoDetectFaces: 'Tự Động Phát Hiện Khuôn Mặt',
    exitManualMode: 'Thoát Chế Độ Thủ Công',
    manualSelect: 'Chọn Thủ Công',
    nFaceRegions: 'Tìm thấy {n} vùng khuôn mặt',
    noFacesDetected: 'Không phát hiện khuôn mặt — sử dụng chế độ thủ công',
    manualHint: 'Nhấp và kéo để vẽ hình chữ nhật trên vùng muốn làm mờ trong ảnh.',
    blurType: 'Loại Làm Mờ',
    blur: 'Làm Mờ',
    emoji: 'Emoji',
    blurIntensity: 'Cường Độ Làm Mờ',
    strength: 'Cường Độ',
    blurShape: 'Hình Dạng Làm Mờ',
    rectangle: 'Hình Chữ Nhật',
    ellipse: 'Hình Ellipse',
    circle: 'Hình Tròn',
    chooseEmoji: 'Chọn Emoji',
    blurRegionsN: 'Vùng Làm Mờ ({n})',
    faceN: 'Khuôn Mặt {n}',
    manualRegionN: 'Vùng Thủ Công {n}',
    manualN: 'Thủ Công {n}',
    clearAllRegions: 'Xóa Tất Cả Vùng',
    processingDots: 'Đang xử lý...',
    downloadBlurred: 'Tải Ảnh Đã Làm Mờ',
    downloadNImages: 'Tải {n} Ảnh',
    downloadDialogTitle: 'Không Phải Tất Cả Ảnh Đã Được Chỉnh Sửa',
    downloadDialogText: 'Bạn đã chỉnh sửa {edited} trong {total} ảnh.',
    downloadAll: 'Tải Tất Cả',
    removeRegion: 'Xóa Vùng',
    region: 'Vùng',
    notAllEdited: 'Không Phải Tất Cả Ảnh Đã Chỉnh Sửa',
    editedXofY: 'Bạn đã chỉnh sửa {edited} trong {total} ảnh.',
    nextImage: 'Ảnh Tiếp Theo',
  },

  faqData: {
    imageConverter: [
      { q: 'Định dạng ảnh nào được hỗ trợ để chuyển đổi?', a: 'Chúng tôi hỗ trợ JPG, PNG, WEBP, SVG, GIF, BMP, ICO và TIFF. Bạn có thể chuyển đổi giữa các định dạng này ngay lập tức trong trình duyệt.' },
      { q: 'Chất lượng ảnh có bị ảnh hưởng trong quá trình chuyển đổi không?', a: 'Đối với định dạng không nén như PNG, chất lượng được giữ nguyên hoàn toàn. Đối với định dạng có nén như JPG và WEBP, chúng tôi sử dụng cài đặt mã hóa được tối ưu hóa.' },
      { q: 'Có giới hạn kích thước hoặc số lượng file không?', a: 'Không có giới hạn nghiêm ngặt. Bạn có thể tải nhiều ảnh cùng lúc và chuyển đổi hàng loạt.' },
      { q: 'Dữ liệu của tôi có an toàn không? Ảnh có được tải lên máy chủ không?', a: 'Tuyệt đối. Tất cả xử lý diễn ra trong trình duyệt của bạn. Ảnh của bạn không bao giờ rời khỏi thiết bị.' },
      { q: 'Tôi có thể chuyển đổi ảnh PNG trong suốt sang JPG không?', a: 'Có. Vì JPG không hỗ trợ độ trong suốt, các vùng trong suốt sẽ được điền bằng nền trắng theo mặc định.' },
    ],
    imageCompressor: [
      { q: 'Nén ảnh có làm giảm chất lượng không?', a: 'Không, việc nén ảnh sẽ không làm giảm chất lượng nếu bạn không vượt quá mức nén khuyến nghị. Hệ thống có chỉ báo để bạn theo dõi: i. Nén 1% đến 40%: hiển thị màu xanh với thông báo “Chất lượng tốt”. ii. Nén 41% đến 60%: hiển thị màu vàng với thông báo “Chất lượng bình thường”; đây là khoảng được khuyến nghị. iii. Nén 61% đến 100%: hệ thống cảnh báo đỏ với thông báo “Chất lượng kém”; trong khoảng này chất lượng có thể giảm thấy rõ.' },
      { q: 'Công cụ hỗ trợ nén những định dạng ảnh nào?', a: 'Công cụ nén ảnh của chúng tôi hỗ trợ đầy đủ các định dạng sau:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Tôi có thể nén nhiều ảnh cùng lúc không?', a: 'Có, hoàn toàn được. Bạn có thể nén nhiều ảnh cùng lúc (thậm chí 100+) nếu thiết bị của bạn đáp ứng được. Vì quá trình nén dùng tài nguyên máy, laptop/PC/điện thoại cấu hình cao sẽ xử lý tốt hơn. Nếu thiết bị yếu hơn, bạn vẫn có thể nén theo từng đợt vì công cụ này miễn phí kể cả khi dùng nhiều batch.' },
      { q: 'Các bạn có lưu hoặc tải ảnh của tôi lên máy chủ không?', a: 'Không. Chúng tôi không tải lên hay lưu ảnh của bạn trên máy chủ. Tất cả ảnh được nén cục bộ trong trình duyệt. Ảnh của bạn không bao giờ rời khỏi thiết bị, vì vậy bạn có thể yên tâm nén ảnh cá nhân hoặc riêng tư.' },
      { q: 'Công cụ nén ảnh này có miễn phí không?', a: 'Có, công cụ nén ảnh của chúng tôi hoàn toàn miễn phí vĩnh viễn. Chúng tôi không yêu cầu bất kỳ khoản thanh toán nào. Không có phí ẩn. Tất cả tính năng, bao gồm nén nhiều ảnh, đều miễn phí.' },
    ],
    cropImage: [
      { q: 'Cắt ảnh có làm giảm chất lượng không?', a: 'Không, cắt ảnh không ảnh hưởng đến chất lượng hiển thị của ảnh. Cắt ảnh chỉ loại bỏ phần không mong muốn. Nó không bao giờ thay đổi các pixel của phần ảnh được giữ lại sau khi cắt. Vì vậy, bạn có thể cắt ảnh với chất lượng gốc mà không có bất kỳ hư hại pixel nào.' },
      { q: 'Công cụ cắt ảnh hỗ trợ những định dạng nào?', a: 'Bạn có thể chọn ảnh ở bất kỳ định dạng nào vì công cụ cắt ảnh của chúng tôi hỗ trợ gần như mọi định dạng ảnh. Danh sách như sau:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Ảnh của tôi có được tải lên máy chủ của bạn không?', a: 'Không, mọi xử lý đều diễn ra trong trình duyệt cục bộ của bạn. Ảnh của bạn không bao giờ được tải lên máy chủ của chúng tôi vì ảnh không rời khỏi thiết bị của bạn. Vì vậy, bạn có thể cắt ảnh cá nhân bằng công cụ cắt ảnh của chúng tôi mà không có bất kỳ rủi ro nào.' },
      { q: 'Tôi có thể cắt nhiều ảnh cùng lúc không?', a: 'Có, bạn có thể cắt nhiều ảnh (thậm chí 100+) cùng lúc nếu hệ thống của bạn hỗ trợ. Vì việc cắt ảnh dùng tài nguyên hệ thống, nên nếu bạn có laptop, PC hoặc điện thoại hiệu năng cao, bạn có thể cắt nhiều ảnh một lúc. Nếu thiết bị cấu hình thấp, bạn có thể cắt theo từng đợt vì công cụ vẫn miễn phí ngay cả khi bạn cắt nhiều ảnh cùng lúc.' },
      { q: 'Công cụ cắt ảnh này có miễn phí không?', a: 'Có, công cụ cắt ảnh này hoàn toàn miễn phí vĩnh viễn. Bạn có thể truy cập ở mọi nơi, bất kỳ lúc nào và trên mọi thiết bị. Bạn không chỉ có trải nghiệm giao diện đáp ứng cho mọi thiết bị mà còn không bao giờ bị yêu cầu trả phí cho bất kỳ tính năng cao cấp nào. Tất cả tính năng đều miễn phí hoàn toàn, không có phí ẩn.' },
    ],
    resizeImage: [
      { q: 'Tôi có thể thay đổi kích thước nhiều ảnh cùng lúc không?', a: 'Có, chắc chắn. Công cụ của chúng tôi hỗ trợ đổi kích thước nhiều ảnh cùng lúc. Bạn có thể tải lên số lượng ảnh theo khả năng thiết bị và AI engine sẽ xử lý đồng thời. Nếu thiết bị yếu, nên chia theo từng batch để tránh giật lag. Toàn bộ xử lý diễn ra cục bộ, không tải lên máy chủ, nên quyền riêng tư luôn được bảo vệ.' },
      { q: 'Công cụ thay đổi kích thước này có miễn phí không?', a: 'Có, công cụ này hoàn toàn miễn phí vĩnh viễn. Không cần đăng ký trả phí để dùng tính năng nâng cao. Cũng không có bất kỳ phí ẩn nào khi tải ảnh đã đổi kích thước.' },
      { q: 'Đổi kích thước ảnh có làm giảm chất lượng không?', a: '✅Decrease Size (downscale): Việc giảm kích thước ảnh không làm giảm chất lượng hiển thị. Trong nhiều trường hợp, ảnh sau khi giảm còn có thể nhìn sắc nét hơn. Vì vậy, giảm xuống kích thước nhỏ hơn thường không gây mất chất lượng.\n❌Increase Size (upscale): Phóng to ảnh vượt kích thước gốc có thể ảnh hưởng chất lượng hiển thị. Mức phóng càng lớn thì khả năng giảm chất lượng càng cao.' },
      { q: 'Công cụ này có an toàn không?', a: 'Có, công cụ của chúng tôi an toàn, đặc biệt với ảnh cá nhân hoặc nhạy cảm. Mọi xử lý đều diễn ra trên thiết bị của bạn và không có dữ liệu nào rời khỏi máy. Bạn có thể đổi kích thước ảnh mà không lo rủi ro quyền riêng tư.' },
      { q: 'Công cụ hỗ trợ những định dạng ảnh nào?', a: 'Công cụ của chúng tôi hỗ trợ mọi định dạng ảnh. Bạn có thể chọn ảnh ở các định dạng sau:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'Xóa nền hoạt động như thế nào?', a: 'Chúng tôi sử dụng mô hình AI tiên tiến chạy trực tiếp trong trình duyệt để phát hiện chủ thể và tách khỏi nền.' },
      { q: 'Có hoạt động với nền phức tạp không?', a: 'Có. Mô hình AI xử lý nhiều loại cảnh. Kết quả tốt nhất khi có độ tương phản rõ ràng giữa chủ thể và nền.' },
      { q: 'Tôi có thể xóa nền từ nhiều ảnh cùng lúc không?', a: 'Có. Tải nhiều ảnh và công cụ sẽ xử lý tuần tự.' },
      { q: 'Định dạng đầu ra là gì?', a: 'Đầu ra luôn là file PNG với nền trong suốt.' },
      { q: 'Ảnh của tôi có được gửi đến máy chủ không?', a: 'Không. Mô hình AI chạy hoàn toàn trong trình duyệt bằng WebAssembly.' },
    ],
    watermarkImage: [
      { q: '1. Công cụ tạo hình mờ của Photremium có hoàn toàn miễn phí không?', a: 'Có, công cụ hình mờ tại photremium.com/watermark-image được dùng miễn phí, không cần tài khoản và không cần đăng ký gói dịch vụ. Bạn có thể gắn hình mờ cho từng ảnh hoặc cả loạt ảnh mà không gặp paywall, không bị yêu cầu đăng ký bắt buộc và không có giới hạn tải xuống. Công cụ này được duy trì bằng cách làm cho toàn bộ nền tảng Photremium đủ hữu ích để người dùng muốn quay lại, chứ không phải bằng cách khóa từng tính năng riêng lẻ.' },
      { q: '2. Tôi có thể gắn hình mờ cho bao nhiêu ảnh cùng lúc?', a: 'Công cụ hỗ trợ gắn hình mờ hàng loạt cho nhiều ảnh cùng lúc. Bạn có thể kéo thả cả một thư mục ảnh vào vùng tải lên, hoặc dùng Ctrl+Click trong hộp chọn tệp để chọn hàng chục tệp một lần. Thanh thumbnail bên trái sẽ hiển thị tất cả ảnh, và khi bạn nhấn “Watermark & Download All”, công cụ sẽ render từng ảnh với các lớp hình mờ đã cấu hình rồi đóng gói chúng vào một tệp ZIP duy nhất, hoặc tải xuống từng tệp riêng nếu bạn muốn. Trên thực tế, kích thước lô bị giới hạn bởi bộ nhớ khả dụng của thiết bị chứ không phải bởi bất kỳ giới hạn nhân tạo nào của công cụ.' },
      { q: '3. Hỗ trợ những định dạng ảnh nào cho đầu vào và đầu ra?', a: 'Đầu vào chấp nhận mọi định dạng ảnh mà File API của trình duyệt xử lý được, về thực tế gồm JPEG, JPG, PNG, WEBP, GIF (tĩnh), BMP và SVG. Ở đầu ra, định dạng sẽ khớp với ảnh gốc: nếu bạn tải lên PNG thì sẽ nhận lại PNG; nếu tải lên JPEG thì sẽ nhận lại JPEG với chất lượng 0,95. Cách giữ nguyên định dạng này giúp bạn không vô tình chuyển một PNG không mất dữ liệu sang JPEG có mất dữ liệu.' },
      { q: '4. Hình mờ có trông giống nhau trên các ảnh có độ phân giải khác nhau không?', a: 'Có, nhờ bộ máy định vị lại theo tỷ lệ của công cụ. Khi bạn có một lô ảnh với kích thước khác nhau, hình mờ sẽ được thiết kế trên ảnh tham chiếu, tức là ảnh bạn đang chọn trong canvas. Khi xuất, bộ máy tính trọng tâm của từng lớp hình mờ trên ảnh tham chiếu, biểu diễn vị trí đó dưới dạng độ lệch theo phần trăm so với tâm ảnh và áp dụng cùng độ lệch tỷ lệ đó lên từng ảnh đích. Kích thước hình mờ cũng được thu/phóng theo tỷ lệ bằng yếu tố nhỏ hơn giữa tỷ lệ chiều rộng và chiều cao để đảm bảo nó không bao giờ vượt ra ngoài khung ảnh. Kết quả là hình mờ giữ nguyên vị trí tương đối và kích thước tương đối trên toàn bộ lô ảnh, ngay cả khi kích thước ảnh thay đổi.' },
      { q: '5. Tôi có thể dùng logo hoặc chữ ký của riêng mình làm hình mờ thay vì văn bản không?', a: 'Hoàn toàn có thể. Nút “Add Image” ở panel bên phải cho phép bạn tải lên bất kỳ ảnh nào từ thiết bị để dùng làm lớp hình mờ. Tệp PNG có nền trong suốt hoạt động tốt nhất vì độ trong suốt được giữ nguyên, nên chỉ logo của bạn hiển thị mà không có khung trắng hay khung màu phía sau. Bạn có thể kéo các góc để đổi kích thước, xoay, lật, điều chỉnh độ mờ và thậm chí thêm viền hoặc bo góc. Nhiều người dùng giữ riêng một phiên bản logo nền trong suốt để dùng cho mục đích gắn hình mờ.' },
      { q: '6. Làm thế nào để tôi làm hình mờ trong suốt hoặc bán trong suốt?', a: 'Chọn lớp hình mờ bằng cách nhấp vào nó. Trong thanh công cụ phía trên xuất hiện, hãy tìm điều khiển độ mờ, nó hiển thị giá trị phần trăm và cho phép bạn nhập trực tiếp hoặc kéo thanh trượt. Nếu bạn muốn một hình mờ tinh tế và chuyên nghiệp, không lấn át nội dung ảnh, mức 30–50% thường là lựa chọn tốt nhất. Nếu bạn muốn thông báo bản quyền rõ hơn và khó bỏ qua hơn, 70–80% sẽ phù hợp. Bạn cũng có thể bật tắt nhanh khả năng hiển thị của lớp trong trình quản lý lớp bằng biểu tượng con mắt để so sánh ảnh có và không có hình mờ.' },
      { q: '7. Tôi có thể thêm nhiều hình mờ vào cùng một ảnh không?', a: 'Có, hệ thống lớp hỗ trợ số lượng lớp hình mờ không giới hạn và mỗi lớp có thể được cấu hình riêng. Bạn có thể có một thông báo bản quyền dạng văn bản ở góc dưới bên phải, một logo ở góc trên bên trái và một lớp phủ dạng tile “SAMPLE” cùng lúc. Mỗi lớp có độ mờ, xoay, vị trí, kích thước và thiết lập kiểu riêng. Trình quản lý lớp ở panel bên phải giúp sắp xếp chúng, và bạn có thể bật hoặc tắt từng lớp mà không cần xóa, rất tiện để thử nhiều kết hợp trước khi hoàn tất.' },
      { q: '8. Tính năng tiling là gì và khi nào nên dùng?', a: 'Tiling sẽ lặp hình mờ của bạn theo dạng lưới trên toàn bộ ảnh. Tùy chọn Grid 2×2 đặt bốn bản sao theo bố cục hai nhân hai; Grid 3×3 đặt chín bản sao theo bố cục ba nhân ba. Điều khiển khoảng cách tile cho phép chỉnh khoảng trống giữa các bản sao. Tiling hữu ích nhất khi bạn muốn làm cho ảnh không thể sử dụng nếu không có sự cho phép. Một hình mờ chỉ đặt ở góc khá dễ bị cắt bỏ, nhưng mẫu phủ toàn ảnh sẽ khiến bức ảnh gần như không thể dùng nếu thiếu hình mờ. Cách này phù hợp cho bản xem trước hợp đồng, ảnh minh họa nháp để khách duyệt, hoặc bất kỳ nội dung nào không nên được sử dụng tự do trước khi thanh toán.' },
      { q: '9. Công cụ này có hoạt động trên điện thoại và máy tính bảng không?', a: 'Có, công cụ hoàn toàn responsive và được thiết kế cho di động. Trên màn hình hẹp hơn 900 pixel, bố cục ba cột sẽ chuyển thành bố cục xếp chồng: dải thumbnail chuyển thành một hàng cuộn ngang ở trên cùng, canvas chiếm vùng chính, và panel cài đặt trở thành một bottom sheet trượt lên khi bạn chạm vào nút bánh răng nổi. Tất cả phần tử tương tác, như kéo lớp, tay nắm thay đổi kích thước và xoay, đều hỗ trợ chạm bằng các sự kiện touchstart và touchmove. Các tay nắm đổi kích thước cũng lớn hơn một chút trên di động, 16×16 pixel thay vì kích thước trên desktop, để dễ chạm chính xác bằng ngón tay hơn.' },
      { q: '10. Dữ liệu ảnh của tôi có riêng tư không? Ảnh của tôi có được tải lên máy chủ nào không?', a: 'Ảnh của bạn không bao giờ rời khỏi thiết bị. Toàn bộ quy trình hình mờ, từ tải ảnh, render lớp cho đến xuất tệp cuối cùng, diễn ra ngay trong trình duyệt của bạn bằng JavaScript và HTML5 Canvas API. Khi bạn tải ảnh lên, File API tạo biểu diễn trong bộ nhớ của tệp. Khi bạn thêm lớp hình mờ, nó được vẽ lên một phần tử canvas ẩn. Khi bạn tải xuống kết quả, dữ liệu pixel của canvas được chuyển thành Blob và đưa cho trình duyệt để tải xuống, hoàn toàn cục bộ. Không có bất kỳ yêu cầu mạng nào chứa dữ liệu ảnh của bạn. Ngoài ra, công cụ còn có bảo vệ khi rời trang: nếu bạn cố đóng hoặc điều hướng đi khi ảnh còn đang mở, trình duyệt sẽ yêu cầu xác nhận để tránh mất phiên làm việc dang dở.' },
    ],
    qrCodeGenerator: [
      { q: 'Mã QR này có hết hạn không?', a: 'Không, những mã QR này không hết hạn và đảm bảo hỗ trợ suốt đời. Vì chúng lưu trữ các hướng dẫn được mã hóa dưới dạng các bit bên trong hộp vuông, thông tin được lưu trữ trong đó không thể được thay đổi hoặc xóa. Bạn có thể truy cập thông tin trong mã chỉ bằng cách quét nó bằng bất kỳ camera nào ngay cả sau nhiều năm.' },
      { q: 'Tại sao mã QR của tôi không quét được?', a: 'Mã QR của bạn có thể không quét được do những lý do sau: i. Độ tương phản thấp: Nếu bạn chọn các màu nền và tiền cảnh tương tự, nó sẽ ảnh hưởng đến khả năng nhìn thấy mã QR và gây ra lỗi quét. Nhưng công cụ của chúng tôi sẽ hướng dẫn bạn trong quá trình tùy chỉnh về độ tương phản thấp hoặc bất kỳ vấn đề liên quan đến quét nào khác. ii. Dữ liệu lớn: Nếu bạn tạo mã QR cho một lượng văn bản hoặc dữ liệu rất lớn, nó sẽ trở nên rất phức tạp và gây ra rắc rối khi quét. Trình xác thực độ dài văn bản sẽ hướng dẫn bạn về độ dài văn bản tối ưu trong quá trình tạo mã QR. iii. In mờ: Hãy chắc chắn tải xuống mã QR của bạn ở định dạng độ phân giải cao như PNG hoặc SVG đã được công cụ của chúng tôi hỗ trợ.' },
      { q: 'Tôi có thể thêm logo vào mã QR không?', a: 'Hoàn toàn có thể, bạn có thể thêm logo tùy chỉnh hoặc chọn một từ thư viện logo có sẵn cho mã QR của bạn. Logo được chọn của bạn sẽ được điều chỉnh tự động ở trung tâm mã QR.' },
      { q: 'Làm cách nào để quét mã QR?', a: 'Bạn có thể quét mã QR bằng camera điện thoại di động. Nhưng để chuyển hướng tự động đến liên kết và nhiều tính năng cao cấp khác, bạn có thể truy cập trình quét mã QR của chúng tôi bằng cách sử dụng liên kết https://photremium.com/qr-code-scanner miễn phí.' },
      { q: 'Tôi có thể tạo bao nhiêu mã QR miễn phí?', a: 'KHÔNG GIỚI HẠN! bạn có thể tạo nhiều mã QR miễn phí. Tất cả các tính năng, tùy chỉnh và mẫu đều miễn phí mãi mãi cho tất cả mọi người. Không cần đăng ký để tận hưởng các tính năng cao cấp.' },
      { q: 'Tôi có cần đăng nhập/đăng ký để tạo mã QR không?', a: 'Không, chỉ cần nhập văn bản của bạn, tạo mã QR và tải xuống sau khi tùy chỉnh. Không cần đăng nhập hoặc đăng ký vì tất cả các tính năng đều có thể truy cập hoàn toàn miễn phí.' },
    ],
    qrCodeScanner: [
      { q: 'Tôi có thể quét mã QR từ ảnh đã lưu và ảnh chụp màn hình không?', a: '**Có**, bạn có thể quét mã QR từ ảnh đã lưu hoặc ảnh chụp màn hình. Trình quét mã QR của chúng tôi https://photremium.com/qr-code-scanner cho phép bạn quét mã QR từ thư viện. Bạn chỉ cần chọn ảnh và bạn sẽ nhận được toàn bộ thông tin được giải mã từ mã QR đó.' },
      { q: 'Tôi có cần cài App để dùng trình quét mã QR không?', a: '**Không**, trình quét mã QR trên web của chúng tôi cho phép bạn quét mã QR mà không cần cài bất kỳ ứng dụng nào. Bạn có thể truy cập trình quét mã QR nâng cao của chúng tôi trên mọi thiết bị miễn phí.' },
      { q: 'Vì sao trình quét không nhận mã QR?', a: 'Mã QR của bạn không quét được do một trong các lý do sau: i. Ánh sáng không đủ: Quét mã QR trong điều kiện thiếu sáng có thể gây khó khăn. Hãy bật đèn pin và tăng độ sáng nếu bạn quét từ màn hình. ii. Khoảng cách: Quét mã QR ở khoảng cách không phù hợp cũng gây lỗi. Khoảng cách tối ưu để quét mã QR là khoảng 10 inch (25cm). iii. Ống kính camera bẩn: Mã QR cũng có thể không quét được do ống kính bẩn. Hãy lau ống kính trước khi quét. “Bạn thấy khung lưới trong trình quét chứ? Chỉ cần đưa mã QR vào trong đó để quét thành công.”' },
      { q: 'Công cụ này có quét được mã QR đảo màu hoặc nhiều màu không?', a: '**Có**, bạn có thể quét QR ở bất kỳ màu sắc hoặc hướng nào. Tuy nhiên, nếu độ tương phản giữa màu nền và màu tiền cảnh thấp, việc quét có thể gặp khó khăn.' },
      { q: 'Công cụ này có miễn phí không?', a: '**Có**, công cụ này hoàn toàn miễn phí để sử dụng. Bạn có thể quét không giới hạn mã QR miễn phí mãi mãi.' },
    ],
    faceBlur: [
      { q: 'Nhận diện khuôn mặt hoạt động như thế nào?', a: 'Mô hình nhận diện khuôn mặt AI chạy trực tiếp trong trình duyệt của bạn. Nó xác định khuôn mặt trong ảnh.' },
      { q: 'Tôi có thể chọn khuôn mặt nào muốn làm mờ không?', a: 'Có. Sau khi phát hiện, mỗi vùng khuôn mặt được đánh dấu và bạn có thể chọn khuôn mặt muốn làm mờ.' },
      { q: 'Có những kiểu làm mờ nào?', a: 'Bạn có thể chọn làm mờ Gaussian, pixel hóa hoặc phủ màu đồng nhất, và điều chỉnh cường độ.' },
      { q: 'Tôi có thể làm mờ khuôn mặt trong nhiều ảnh cùng lúc không?', a: 'Có. Tải nhiều ảnh, cấu hình vùng làm mờ, sau đó tải tất cả ảnh đã xử lý về.' },
      { q: 'Ảnh của tôi có được gửi đến máy chủ từ xa không?', a: 'Không. Mô hình AI chạy trong trình duyệt của bạn bằng WebAssembly.' },
    ],
    photoEditor: [
      { q: 'Có những tính năng chỉnh sửa nào?', a: 'Điều chỉnh độ sáng, độ tương phản, độ bão hòa, áp dụng bộ lọc, thêm văn bản, lớp phủ, khung và nhãn dán — tất cả trong trình duyệt.' },
      { q: 'Tôi có thể hoàn tác và làm lại các thay đổi không?', a: 'Có. Trình chỉnh sửa hỗ trợ lịch sử hoàn tác/làm lại đầy đủ.' },
      { q: 'Có thể chỉnh sửa và xuất những định dạng file nào?', a: 'Bạn có thể chỉnh sửa JPG, PNG, WEBP và các định dạng phổ biến khác.' },
      { q: 'Trình chỉnh sửa có hoạt động trên điện thoại không?', a: 'Có. Trình chỉnh sửa hoàn toàn responsive và thân thiện với màn hình cảm ứng.' },
      { q: 'Ảnh của tôi có được lưu trên máy chủ không?', a: 'Không. Tất cả chỉnh sửa được thực hiện cục bộ.' },
    ],
  },
};

export default vi;
